/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * CIT
 * OpenAPI spec version: 1.0
 */
export interface AcademicRecord {
  /** @nullable */
  schoolName?: string | null;
  class?: IdNameModel;
  year?: number;
  marks?: number;
  percentage?: number;
  studyMode?: StudyMode;
  curriculum?: IdNameModel;
  stream?: IdNameModel;
}

export type ActionBioType = typeof ActionBioType[keyof typeof ActionBioType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionBioType = {
  Undefined: 0,
  AssignAccessOnly: 1,
  AssignAccess: 2,
  RemoveAccess: 3,
  EnableAttSync: 4,
  DisableAttSync: 5,
} as const;

export interface AddEnquiryCounselor {
  /** @nullable */
  id?: string[] | null;
  /** @nullable */
  counselors?: IdNameModel[] | null;
  date?: string;
}

export interface AddLocationModel {
  /**
   * @minLength 0
   * @maxLength 150
   * @nullable
   */
  building?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   * @nullable
   */
  street?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   * @nullable
   */
  city?: string | null;
  /** @nullable */
  state?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   * @nullable
   */
  postcode?: string | null;
  /** @nullable */
  country?: string | null;
}

export interface AddQuestionPaperReq {
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  subject?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  examName?: string | null;
  /** @nullable */
  assessmentId?: string | null;
  timeLimit?: number;
  subjectDetail?: SubjectDetail;
  isStrictTime?: boolean;
  isRestrictionEnabled?: boolean;
  isCheckAttendance?: boolean;
  codeLanguage?: CodeLanguage;
  /** @nullable */
  questionPaperDetails?: QuestionPaperRes[] | null;
  examType?: ExamType;
  examTemplate?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AddStudentExamAnswerReq {
  exam?: IdNameModel;
  student?: IdNameModel;
}

export interface AllSubjectMarksReq {
  /** @nullable */
  assessmentId?: string | null;
  /** @nullable */
  student?: SubjectMarksDetails[] | null;
}

export type AllowDocumentsFor = typeof AllowDocumentsFor[keyof typeof AllowDocumentsFor];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllowDocumentsFor = {
  ForAdmin: 0,
  ForStudnetAndAdmin: 1,
  ForOfficalDocuments: 2,
} as const;

/**
 * @nullable
 */
export type ApiErrorException = unknown | null;

export interface ApiError {
  number?: number;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  suggestion?: string | null;
  /** @nullable */
  exception?: ApiErrorException;
}

export interface AppClassScheduleReq {
  isPresent?: boolean;
  schedule?: IdNameModel;
  section?: IdNameModel;
  type?: PeriodTypeEnum;
  /** @nullable */
  workDay?: string | null;
  startTime?: string;
  endTime?: string;
  subject?: IdNameModel;
  /** @nullable */
  title?: string | null;
  primaryTeacher?: IdNameModel;
  room?: IdNameModel;
  semester?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AppClassScheduleReqListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: AppClassScheduleReq[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppCourseDetailRes {
  /** @nullable */
  courses?: IdNameModel[] | null;
  /** @nullable */
  semesters?: IdNameModel[] | null;
  /** @nullable */
  section?: IdNameModel[] | null;
  /** @nullable */
  assessmentCategory?: IdNameModel[] | null;
  studentDesignCourse?: StudentDesignCourse;
}

export interface AppCourseDetailResApiResponse {
  readonly executionTime?: number;
  result?: AppCourseDetailRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppLeave {
  /** @nullable */
  remark?: string | null;
  leaveType?: IdNameBool;
  date?: DateFromTo;
  /** @nullable */
  reason?: string | null;
  batch?: IdNameModel;
  department?: IdNameModel;
  userId?: string;
  student?: IdNameModel;
  approvedBy?: RecordUpdateInfo;
  status?: LeaveStatusEnum;
  /** @nullable */
  attachments?: FileNameModel[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AppLeaveApiResponse {
  readonly executionTime?: number;
  result?: AppLeave;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppLeaveListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: AppLeave[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppLeavePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: AppLeave[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface AppLeavePagedDataApiResponse {
  readonly executionTime?: number;
  result?: AppLeavePagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppSupport {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  note?: string | null;
  deviceDetails?: Device;
  /** @nullable */
  remark?: string | null;
  student?: IdNameModel;
  batch?: IdNameModel;
  approvedBy?: RecordUpdateInfo;
  status?: LeaveStatusEnum;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AppSupportApiResponse {
  readonly executionTime?: number;
  result?: AppSupport;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppSupportListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: AppSupport[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AppUserLogInRequest {
  /** @minLength 1 */
  userName: string;
  /** @minLength 1 */
  password: string;
  fcm_Token?: FcmToken;
}

export interface AppVersion {
  /** @nullable */
  androidVersion?: string | null;
  /** @nullable */
  iosVersion?: string | null;
  isAndroidMandatory?: boolean;
  isIosMandatory?: boolean;
  isMaintainance?: boolean;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AppVersionApiResponse {
  readonly executionTime?: number;
  result?: AppVersion;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ApplicationUser {
  isTwoFactorEnabled?: boolean;
  /** @nullable */
  twoFactorSecretKey?: string | null;
  /** @nullable */
  otpExpiry?: string | null;
  status?: ApplicationUserStatus;
  name?: NameModel;
  /** @nullable */
  otp?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  departments?: IdNameModel[] | null;
  rights?: Rights;
  roleType?: RoleTypes;
  /** @nullable */
  address?: string | null;
  company?: IdNameModel;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
  /** @nullable */
  agentId?: string | null;
  isDefaultPassword?: boolean;
  isFirst2FASuggestion?: boolean;
  /** @nullable */
  callerId?: string | null;
  lastLogin?: ApplicationUserLastLoginDetail;
  picture?: ApplicationUserPicture;
  userImage?: FileNameModel;
  /** @nullable */
  updateId?: string | null;
  sno?: number;
  /** @nullable */
  fcmTokens?: FcmToken[] | null;
  isFirstLogin?: boolean;
  isForceLogout?: boolean;
  isWebForceLogout?: boolean;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  lockoutEndDateUtc?: string | null;
  /** @nullable */
  roles?: string[] | null;
}

export interface ApplicationUserApiResponse {
  readonly executionTime?: number;
  result?: ApplicationUser;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ApplicationUserLastLoginDetail {
  time?: string;
  /** @nullable */
  ip?: string | null;
  /** @nullable */
  browser?: string | null;
  /** @nullable */
  countryCode?: string | null;
  /** @nullable */
  countryName?: string | null;
  /** @nullable */
  cityName?: string | null;
}

export interface ApplicationUserPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: ApplicationUser[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface ApplicationUserPagedDataApiResponse {
  readonly executionTime?: number;
  result?: ApplicationUserPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ApplicationUserPicture {
  /** @nullable */
  imagePath?: string | null;
  /** @nullable */
  thumbPath?: string | null;
}

export type ApplicationUserStatus = typeof ApplicationUserStatus[keyof typeof ApplicationUserStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApplicationUserStatus = {
  Active: 0,
  Inactive: 1,
  Deleted: 2,
} as const;

export interface ApprovedResponse {
  /** @nullable */
  approved?: string[] | null;
  /** @nullable */
  notApproved?: NotApprovedItem[] | null;
}

export interface ApprovedResponseApiResponse {
  readonly executionTime?: number;
  result?: ApprovedResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentFullDetailsRes {
  /** @nullable */
  assessmentName?: string | null;
  isCountOverallScore?: boolean;
  department?: IdNameModel;
  category?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  assessmentDetails?: AssessmentSubjectDetails[] | null;
}

export interface AssessmentFullDetailsResApiResponse {
  readonly executionTime?: number;
  result?: AssessmentFullDetailsRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentResType {
  /** @nullable */
  assessmentName?: string | null;
  isCountOverallScore?: boolean;
  category?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  from?: string;
  to?: string;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AssessmentResTypePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: AssessmentResType[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface AssessmentResTypePagedDataApiResponse {
  readonly executionTime?: number;
  result?: AssessmentResTypePagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentSubjectDetail {
  assessment?: Assessments;
  subject?: AssessmentSubjectDetails;
}

export interface AssessmentSubjectDetailApiResponse {
  readonly executionTime?: number;
  result?: AssessmentSubjectDetail;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentSubjectDetails {
  assessmentId?: string;
  subject?: IdNameModel;
  maxMarks?: number;
  passingMarks?: number;
  date?: string;
  time?: FromToModel;
  teacher?: IdNameModel;
  /** @nullable */
  students?: SubjectMarksDetails[] | null;
  examType?: ExamType;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AssessmentSubjectDetailsListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: AssessmentSubjectDetails[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface Assessments {
  category?: IdNameModel;
  /** @nullable */
  assessmentName?: string | null;
  isCountOverallScore?: boolean;
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  tz?: string | null;
  /** @nullable */
  assessmentDetails?: AssessmentSubjectDetails[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AssessmentsApiResponse {
  readonly executionTime?: number;
  result?: Assessments;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentsListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: Assessments[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentsWeight {
  course?: IdNameModel;
  schemas?: IdNameModel;
  semester?: IdNameModel;
  subject?: IdNameModel;
  isCommon?: boolean;
  /** @nullable */
  weightArr?: IdNameWeight[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AssessmentsWeightApiResponse {
  readonly executionTime?: number;
  result?: AssessmentsWeight;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AssessmentsWeightPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: AssessmentsWeight[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface AssessmentsWeightPagedDataApiResponse {
  readonly executionTime?: number;
  result?: AssessmentsWeightPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AttPunchTimeViewModel {
  /** @nullable */
  attId?: string | null;
  attDate?: string;
  time?: string;
}

export interface AttRequest {
  /** @nullable */
  remark?: string | null;
  date?: string;
  /** @nullable */
  reason?: string | null;
  student?: IdNameModel;
  batch?: IdNameModel;
  userId?: string;
  status?: LeaveStatusEnum;
  attRequestType?: AttRequestType;
  /** @nullable */
  timeData?: string[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AttRequestApiResponse {
  readonly executionTime?: number;
  result?: AttRequest;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AttRequestListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: AttRequest[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AttRequestPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: AttRequest[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface AttRequestPagedDataApiResponse {
  readonly executionTime?: number;
  result?: AttRequestPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type AttRequestType = typeof AttRequestType[keyof typeof AttRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttRequestType = {
  Undefined: 0,
  CorrectionCard: 1,
  MissingCard: 2,
} as const;

export interface AttSheetRecord {
  /** @nullable */
  day?: string | null;
  /** @nullable */
  attendance?: string | null;
  attDate?: string;
}

export interface AttSheetResponse {
  /** @nullable */
  id?: string | null;
  enrolledDate?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  records?: AttSheetRecord[] | null;
  /** @nullable */
  leaveArr?: AppLeave[] | null;
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  holidays?: unknown[] | null;
}

export interface AttSheetWithHolidays {
  /** @nullable */
  students?: AttSheetResponse[] | null;
  /** @nullable */
  holidaysArr?: unknown[] | null;
  /** @nullable */
  leaveArr?: unknown[] | null;
}

export interface AttSheetWithHolidaysPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: AttSheetWithHolidays[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface AttSheetWithHolidaysPagedDataApiResponse {
  readonly executionTime?: number;
  result?: AttSheetWithHolidaysPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AttTrans {
  time?: string;
  isManual?: boolean;
}

export interface AttWithBatchViewModel {
  timeSchedule?: TimeSchedule;
  attendance?: Attendance;
}

export interface AttWithBatchViewModelApiResponse {
  readonly executionTime?: number;
  result?: AttWithBatchViewModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface Attachment {
  documentIsVerified?: boolean;
  fileType?: IdNameModel;
  fileName?: FileNameModel;
  /** @nullable */
  description?: string | null;
  category?: AttachmentsCategory;
  innerCategory?: AttachmentsInnerCategory;
  updateInfo?: RecordUpdateInfo;
  isDelete?: boolean;
  /** @nullable */
  bytes?: string | null;
}

export interface AttachmentListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: Attachment[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type AttachmentsCategory = typeof AttachmentsCategory[keyof typeof AttachmentsCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentsCategory = {
  Undefined: 0,
  Note: 1,
  CallLog: 2,
  Email: 3,
  Meeting: 4,
  Task: 5,
  StudentDocuments: 6,
  EmailInvoice: 7,
  Lsbu: 8,
} as const;

export type AttachmentsInnerCategory = typeof AttachmentsInnerCategory[keyof typeof AttachmentsInnerCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentsInnerCategory = {
  Undefined: 0,
  CV: 1,
  StudyContact: 2,
} as const;

export type AttandanceStatusType = typeof AttandanceStatusType[keyof typeof AttandanceStatusType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttandanceStatusType = {
  Undefined: 0,
  Present: 1,
  Absent: 2,
  Leave: 3,
} as const;

export interface Attendance {
  cardNo?: number;
  /** @nullable */
  studentId?: string | null;
  biometricCode?: number;
  student?: IdNameModel;
  attendanceDate?: string;
  /** @nullable */
  dayTrans?: AttTrans[] | null;
  dayIn?: string;
  dayOut?: string;
  batch?: IdNameModel;
  type?: AttendanceStatus;
  isPresent?: boolean;
  isAbsent?: boolean;
  isHoliday?: boolean;
  isWeekOff?: boolean;
  isLeave?: boolean;
  in?: string;
  out?: string;
  requiredMinute?: number;
  studyMinute?: number;
  inDiff?: number;
  outDiff?: number;
  /** @nullable */
  leaveReason?: string | null;
  /** @nullable */
  leaveType?: string | null;
  lunchMinute?: number;
  /** @nullable */
  readonly abbreviation?: string | null;
  /** @nullable */
  holidayName?: string | null;
  /** @nullable */
  remark?: string | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface AttendanceApiResponse {
  readonly executionTime?: number;
  result?: Attendance;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface AttendanceRecord {
  attDate?: string;
  /** @nullable */
  studentName?: string | null;
  /** @nullable */
  dayTrans?: AttTrans[] | null;
  /** @nullable */
  studentId?: string | null;
  in?: string;
  out?: string;
  status?: AttendanceStatus;
  batchDayIn?: string;
  batchDayOut?: string;
}

export type AttendanceStatus = typeof AttendanceStatus[keyof typeof AttendanceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttendanceStatus = {
  Absent: 0,
  Present: 1,
  Leave: 2,
} as const;

export interface AttendanceViewModel {
  /** @nullable */
  stuId?: string | null;
  /** @nullable */
  attId?: string | null;
  attDate?: string;
  /** @nullable */
  attStatus?: string | null;
  /** @nullable */
  remark?: string | null;
  leaveType?: IdNameModel;
}

export interface BatchDaysModel {
  day?: WeekDay;
  isChecked?: boolean;
}

export type BioDeviceOptionsEnum = typeof BioDeviceOptionsEnum[keyof typeof BioDeviceOptionsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BioDeviceOptionsEnum = {
  all: 0,
  accessOnly: 1,
  accessAndAttendance: 2,
} as const;

export interface BioMachine {
  /** @nullable */
  machineTitle?: string | null;
  /** @nullable */
  machineNo?: string | null;
  isActive?: boolean;
  isRegisterToBio?: boolean;
  isAttSync?: boolean;
}

export interface BioMatricDeviceActionReq {
  /** @nullable */
  machines?: BioMatricMachines[] | null;
}

export interface BioMatricMachines {
  /** @nullable */
  id?: string | null;
  /** @minLength 1 */
  machineNo: string;
  /** @minLength 1 */
  machineTitle: string;
  type?: BiometricDeviceStatusType;
}

export interface BiometricAttTrans {
  userPin?: number;
  time?: string;
}

export type BiometricDeviceStatusType = typeof BiometricDeviceStatusType[keyof typeof BiometricDeviceStatusType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiometricDeviceStatusType = {
  Add: 1,
  Update: 2,
  Delete: 3,
} as const;

export interface BooleanApiResponse {
  readonly executionTime?: number;
  result?: boolean;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface BulkAttendanceModel {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  attId?: string | null;
  attDate?: string;
  status?: AttendanceStatus;
}

export interface BulkAttendanceModelPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: BulkAttendanceModel[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface BulkAttendanceModelPagedDataApiResponse {
  readonly executionTime?: number;
  result?: BulkAttendanceModelPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CallLog {
  /** @nullable */
  uuid?: string | null;
  date?: string;
  /** @nullable */
  callStatus?: string | null;
  /** @nullable */
  callDir?: string | null;
  /** @nullable */
  recording_url?: string | null;
  /** @nullable */
  callType?: string | null;
  duration?: number;
  counsellor?: IdNameModel;
  /** @nullable */
  hangupCause?: string | null;
}

export interface CallLogListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: CallLog[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CallLogViewList {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  number?: string | null;
  enquiry?: IdNameModel;
  lastCallDate?: string;
  lastCallCounsellor?: IdNameModel;
  rejectEnquiry?: RejectEnquiryClass;
  /** @nullable */
  callStatus?: string | null;
  /** @nullable */
  callType?: string | null;
  isAllMissCalls?: boolean;
}

export interface CallLogViewListPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: CallLogViewList[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface CallLogViewListPagedDataApiResponse {
  readonly executionTime?: number;
  result?: CallLogViewListPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type CallType = typeof CallType[keyof typeof CallType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CallType = {
  Unknown: 0,
  Incoming: 1,
  Outgoing: 2,
} as const;

export interface CancelLeaveReq {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  remark: string;
}

export type CandidateRequestType = typeof CandidateRequestType[keyof typeof CandidateRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CandidateRequestType = {
  Undefine: 0,
  Enquire: 1,
  Student: 2,
  Rejected: 3,
  Walkins: 4,
} as const;

export type CenterVisited = typeof CenterVisited[keyof typeof CenterVisited];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CenterVisited = {
  Undefined: 0,
  Yes: 1,
  No: 2,
} as const;

export interface ChangeCounselorsCallStatusReq {
  /** @nullable */
  id?: string | null;
  enquiryCallStatus?: EnquiryCallStatusEnum;
  /** @nullable */
  note?: string | null;
  date?: string;
}

export interface ChangeEnquiryCommunicationDetailsReq {
  /** @nullable */
  id?: string[] | null;
  /** @nullable */
  counselors?: IdNameModel[] | null;
  date?: string;
}

export interface ChangePasswordForApp {
  /** @nullable */
  currentPassword?: string | null;
  /**
   * @minLength 6
   * @maxLength 50
   */
  newPassword: string;
  /** @nullable */
  confirmPassword?: string | null;
}

export interface ChangePasswordViewModel {
  /** @minLength 1 */
  currentPassword: string;
  /**
   * @minLength 6
   * @maxLength 50
   */
  newPassword: string;
  /** @nullable */
  confirmPassword?: string | null;
}

export interface Changes {
  /** @nullable */
  from?: string | null;
  /** @nullable */
  to?: string | null;
  /** @nullable */
  fieldName?: string | null;
  dataType?: DataTypeEnum;
  /** @nullable */
  path?: string | null;
}

export interface CheckOrderStatusRes {
  paymentStatus?: HdfcOrderStatus;
  orderId?: number;
  amount?: number;
}

export interface CheckOrderStatusResApiResponse {
  readonly executionTime?: number;
  result?: CheckOrderStatusRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ClassScheduleModel {
  subject?: IdNameModel;
  /** @nullable */
  title?: string | null;
  primaryTeacher?: IdNameModel;
  /** @nullable */
  classDays?: WorkingDays[] | null;
  /** @nullable */
  timeOption?: TimeOptions[] | null;
  startTime?: string;
  endTime?: string;
  room?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ClassScheduleModelApiResponse {
  readonly executionTime?: number;
  result?: ClassScheduleModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type ClassStatus = typeof ClassStatus[keyof typeof ClassStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClassStatus = {
  Passed: 0,
  Pursuing: 1,
} as const;

export interface ClassTenthDetail {
  /** @nullable */
  schoolName?: string | null;
  medium?: IdNameModel;
  board?: IdNameModel;
  stream?: IdNameModel;
  passOutYear?: number;
  percentage?: number;
}

export interface CodeExecuteRes {
  /** @nullable */
  output?: string | null;
  statusCode?: number;
  /** @nullable */
  memory?: string | null;
  /** @nullable */
  cpuTime?: string | null;
  isCompiled?: boolean;
  isExecutionSuccess?: boolean;
}

export interface CodeExecuteResApiResponse {
  readonly executionTime?: number;
  result?: CodeExecuteRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CodeLanguage {
  /** @nullable */
  language?: string | null;
  /** @nullable */
  versionIndex?: string | null;
  isFrontEnd?: boolean;
}

export interface CodeRequest {
  /** @nullable */
  script?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  versionIndex?: string | null;
}

export interface CommunicationEnquiryLookup {
  enquiry?: Enquiry;
  /** @nullable */
  enquiryId?: string | null;
  type?: CommunicationType;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  note?: string | null;
  date?: string;
  followUpDate?: string;
  /** @nullable */
  attachments?: Attachment[] | null;
  callType?: CallType;
  number?: number;
  outcomeType?: OutcomeType;
  followUpTask?: boolean;
  startDate?: string;
  dueDate?: string;
  startTime?: string;
  endTime?: string;
  /** @nullable */
  formMail?: string | null;
  /** @nullable */
  toMail?: string | null;
  /** @nullable */
  subject?: string | null;
  selectTemplate?: IdNameModel;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  assignTo?: IdNameModel[] | null;
  meetingType?: MeetingType;
  platform?: IdNameModel;
  /** @nullable */
  meetingAddress?: string | null;
  reminder?: IdNameModel;
  taskType?: IdNameModel;
  dueTime?: string;
  attachmentsCategory?: AttachmentsCategory;
  /** @nullable */
  body?: string | null;
  schedule?: string;
  enquiryCallStatus?: EnquiryCallStatusEnum;
  enquiryCalledDate?: string;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface CommunicationEnquiryLookupListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: CommunicationEnquiryLookup[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type CommunicationType = typeof CommunicationType[keyof typeof CommunicationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommunicationType = {
  Unknown: 0,
  Note: 1,
  CallLog: 2,
  Mail: 3,
  Metting: 4,
  Task: 5,
} as const;

export interface CompanyModel {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  compIdPrefix?: string | null;
  /** @nullable */
  phoneNo?: string | null;
  /** @nullable */
  email?: string | null;
  address?: AddLocationModel;
  userName?: NameModel;
  /** @nullable */
  userEmail?: string | null;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface CompanyModelApiResponse {
  readonly executionTime?: number;
  result?: CompanyModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CompanyModelPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: CompanyModel[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface CompanyModelPagedDataApiResponse {
  readonly executionTime?: number;
  result?: CompanyModelPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ConfigDTO {
  /** @nullable */
  outerStepID?: string | null;
  /** @nullable */
  innerStepID?: string | null;
  checkInnerStepID?: boolean;
}

export interface ContactDetail {
  mobileNumber?: number;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  currentAddress?: string | null;
  /** @nullable */
  permanentAddress?: string | null;
  emergencyNumber?: number;
}

export interface CourseDetailRes {
  /** @nullable */
  departments?: Master[] | null;
  /** @nullable */
  courses?: Master[] | null;
  /** @nullable */
  schemas?: Master[] | null;
  /** @nullable */
  semesters?: Master[] | null;
  /** @nullable */
  subjects?: Master[] | null;
  /** @nullable */
  batch?: Master[] | null;
  /** @nullable */
  section?: Master[] | null;
  /** @nullable */
  subject?: Master[] | null;
}

export interface CourseDetailResApiResponse {
  readonly executionTime?: number;
  result?: CourseDetailRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CourseDetailTable {
  sno?: number;
  /** @nullable */
  semesterName?: string | null;
  /** @nullable */
  subjects?: IdNameModel[] | null;
}

export interface CourseDetailsReq {
  /** @nullable */
  departmentId?: string | null;
  /** @nullable */
  courseId?: string | null;
  /** @nullable */
  schemaId?: string | null;
  /** @nullable */
  semesterId?: string | null;
  /** @nullable */
  batchId?: string | null;
}

export interface CourseDetailsResponse {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  department?: IdNameModel;
  currentSchema?: IdNameModel;
  /** @nullable */
  alias?: string | null;
  schema?: Schema;
  /** @nullable */
  tableData?: CourseDetailTable[] | null;
}

export interface CourseDetailsResponseApiResponse {
  readonly executionTime?: number;
  result?: CourseDetailsResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CreateScheduleModel {
  type?: ScheduleCategory;
  date?: FromToModel;
  /** @nullable */
  name?: string | null;
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  /** @nullable */
  section?: IdNameModel[] | null;
  /** @nullable */
  workingDays?: WorkingDays[] | null;
  /** @nullable */
  workDays?: string[] | null;
  startTime?: string;
  endTime?: string;
  /** @nullable */
  schdeuleTime?: StartEndTime[] | null;
  durationMinutes?: number;
  /** @nullable */
  sessionBreaks?: SessionBreak[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface CreateScheduleModelApiResponse {
  readonly executionTime?: number;
  result?: CreateScheduleModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CreateScheduleModelPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: CreateScheduleModel[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface CreateScheduleModelPagedDataApiResponse {
  readonly executionTime?: number;
  result?: CreateScheduleModelPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface CurrentSchemaResponse {
  /** @nullable */
  id?: string | null;
  schema?: IdNameModel;
}

export interface CurrentSchemaResponseApiResponse {
  readonly executionTime?: number;
  result?: CurrentSchemaResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface DashBoardModel {
  enroll?: number;
  hold?: number;
  rejected?: number;
  totalEnquiry?: number;
  centerVisitedCount?: number;
  /** @nullable */
  streamGroupBy?: StreamGroupModel[] | null;
  inActive?: number;
  male?: number;
  female?: number;
  paidFees?: number;
  dueStudentFees?: number;
  dueStudentLeftFees?: number;
  presentStudent?: number;
  absentStudent?: number;
  /** @nullable */
  upCommingHoliday?: Master[] | null;
  /** @nullable */
  sourcesGroupBy?: SourceGroupModel[] | null;
  total?: PaymentGraphData;
  totalPaidAmountByStudent?: number;
  /** @nullable */
  websiteEnqData?: WebsiteEnquiryGroupDataRes[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface DashBoardModelApiResponse {
  readonly executionTime?: number;
  result?: DashBoardModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataTypeEnum = {
  Undefined: 0,
  DateTime: 1,
  String: 2,
  Number: 3,
  Boolean: 4,
} as const;

export interface DateFromTo {
  from?: string;
  to?: string;
}

export type DateType = typeof DateType[keyof typeof DateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DateType = {
  Undefined: 0,
  EnrollDate: 1,
} as const;

export interface DesignCourseIds {
  /** @nullable */
  department?: string[] | null;
  /** @nullable */
  course?: string[] | null;
  /** @nullable */
  schema?: string[] | null;
  /** @nullable */
  batch?: string[] | null;
  /** @nullable */
  section?: string[] | null;
}

export interface Details {
  section?: IdNameModel;
  semester?: IdNameModel;
  subjects?: IdNameModel;
}

export interface Device {
  /** @nullable */
  deviceName?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  systemVersion?: string | null;
  /** @nullable */
  appVersion?: string | null;
  /** @nullable */
  deviceWidth?: string | null;
  /** @nullable */
  deviceHeight?: string | null;
}

export interface DownloadRequestModel {
  /** @nullable */
  incrementalSeries?: string | null;
}

export interface Ecard {
  /** @nullable */
  cardNo?: string | null;
  isCardDeActive?: boolean;
  bioCmdId?: number;
  /** @nullable */
  bioMachines?: BioMachine[] | null;
  /** @nullable */
  visitorCardNo?: string | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface EcardApiResponse {
  readonly executionTime?: number;
  result?: Ecard;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EmployeeReferral {
  referralEmployeeId?: IdNameModel;
  /** @nullable */
  referralEmployeeRelation?: string | null;
}

export interface Enable2FARequest {
  /** @nullable */
  userId?: string | null;
}

export interface Enquiry {
  /** @nullable */
  enquiryNumber?: string | null;
  orderNumber?: number;
  /** @nullable */
  isReAdmission?: boolean | null;
  /** @nullable */
  reason?: string | null;
  isDefaultPassword?: boolean;
  /** @nullable */
  enrollmentNumber?: string | null;
  /** @nullable */
  aadharNumber?: string | null;
  /** @nullable */
  abcId?: string | null;
  /** @nullable */
  debId?: string | null;
  reject?: Reject;
  /** @nullable */
  bloodGroup?: string | null;
  processStep?: ProcessStepData;
  sno?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  middleName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  nationality?: string | null;
  zipcode?: number;
  /** @nullable */
  city?: string | null;
  state?: IndianState;
  /** @nullable */
  fatherName?: string | null;
  /** @nullable */
  motherName?: string | null;
  /** @nullable */
  fatherOccupation?: string | null;
  /** @nullable */
  motherOccupation?: string | null;
  cardNo?: number;
  userId?: string;
  /** @nullable */
  studentId?: string | null;
  biometricCode?: number;
  dateOfBirth?: string;
  enrolledDate?: string;
  enquiryDate?: string;
  gender?: IdNameModel;
  category?: IdNameModel;
  englishProficiency?: LanguageProficiency;
  currentPassOutYear?: number;
  /** @nullable */
  otherLanguages?: string | null;
  roleType?: RoleTypes;
  /** @nullable */
  currentSchoolName?: string | null;
  curriculum?: IdNameModel;
  stream?: IdNameModel;
  /** @nullable */
  otherInformation?: string | null;
  /** @nullable */
  reference?: string | null;
  approvalStatus?: IdNameModel;
  amount?: number;
  /** @nullable */
  referralSource?: string | null;
  signature?: Signature;
  counselorName?: IdNameModel;
  candidateImage?: FileNameModel;
  /** @nullable */
  academicRecord?: AcademicRecord[] | null;
  contactDetail?: ContactDetail;
  batch?: IdNameModel;
  medium?: IdNameModel;
  attendance?: AttendanceStatus;
  /** @nullable */
  credentials?: StudentCredentials[] | null;
  /** @nullable */
  attachments?: Attachment[] | null;
  currentClass?: IdNameModel;
  classStatus?: ClassStatus;
  /** @nullable */
  qualification?: string | null;
  counsellingSession?: boolean;
  mode?: EnquiryType;
  isIncomingCall?: boolean;
  enquiryCommunication?: EnquiryCommunication;
  sources?: IdNameModel;
  /** @nullable */
  assignTo?: IdNameModel[] | null;
  percentage?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  centerVisited?: CenterVisited;
  response?: Response;
  guardianState?: IndianState;
  /** @nullable */
  guardianCity?: string | null;
  /** @nullable */
  guardianName?: string | null;
  /** @nullable */
  guardianRelation?: string | null;
  guardianPhone?: number;
  /** @nullable */
  guardianOccupation?: string | null;
  /** @nullable */
  guardianAddress?: string | null;
  guardianZipCode?: number;
  /** @nullable */
  counselors?: IdNameModel[] | null;
  counselor?: IdNameModel;
  sameAsCandidateAddress?: boolean;
  isEnrolled?: boolean;
  /** @nullable */
  noteForWithoutFees?: string | null;
  isActive?: boolean;
  ecard?: Ecard;
  isDelete?: boolean;
  department?: IdNameModel;
  course?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  officialEmail?: string | null;
  /** @nullable */
  mentorName?: string | null;
  /** @nullable */
  centerCity?: string | null;
  registrationFees?: RegistrationFees;
  employeeReferral?: EmployeeReferral;
  classTenthDetail?: ClassTenthDetail;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface EnquiryApiResponse {
  readonly executionTime?: number;
  result?: Enquiry;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EnquiryBySource {
  sno?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  recordStatus?: RecordStatusType;
  contactDetail?: ContactDetail;
  reject?: Reject;
  isEnrolled?: boolean;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
  currentClass?: IdNameModel;
  /** @nullable */
  middleName?: string | null;
  enquiryDate?: string;
  sources?: IdNameModel;
  processStep?: ProcessStepData;
  centerVisited?: CenterVisited;
  /** @nullable */
  centerCity?: string | null;
}

export interface EnquiryBySourcePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: EnquiryBySource[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface EnquiryBySourcePagedDataEnquiryBySourceResponse {
  data?: EnquiryBySourcePagedData;
  enquiryGroupBySource?: EnquiryGroupBySource;
}

export interface EnquiryBySourcePagedDataEnquiryBySourceResponseApiResponse {
  readonly executionTime?: number;
  result?: EnquiryBySourcePagedDataEnquiryBySourceResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type EnquiryCallStatusEnum = typeof EnquiryCallStatusEnum[keyof typeof EnquiryCallStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnquiryCallStatusEnum = {
  Undefined: 0,
  Interested: 1,
  Pending: 2,
  NotInterested: 3,
  FollowUp: 4,
  NotCalled: 5,
} as const;

export interface EnquiryCommunication {
  /** @nullable */
  enquiryId?: string | null;
  type?: CommunicationType;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  note?: string | null;
  date?: string;
  followUpDate?: string;
  /** @nullable */
  attachments?: Attachment[] | null;
  callType?: CallType;
  number?: number;
  outcomeType?: OutcomeType;
  followUpTask?: boolean;
  startDate?: string;
  dueDate?: string;
  startTime?: string;
  endTime?: string;
  /** @nullable */
  formMail?: string | null;
  /** @nullable */
  toMail?: string | null;
  /** @nullable */
  subject?: string | null;
  selectTemplate?: IdNameModel;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  assignTo?: IdNameModel[] | null;
  meetingType?: MeetingType;
  platform?: IdNameModel;
  /** @nullable */
  meetingAddress?: string | null;
  reminder?: IdNameModel;
  taskType?: IdNameModel;
  dueTime?: string;
  attachmentsCategory?: AttachmentsCategory;
  /** @nullable */
  body?: string | null;
  schedule?: string;
  enquiryCallStatus?: EnquiryCallStatusEnum;
  enquiryCalledDate?: string;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface EnquiryCommunicationApiResponse {
  readonly executionTime?: number;
  result?: EnquiryCommunication;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EnquiryCommunicationListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: EnquiryCommunication[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type EnquiryCounselorType = typeof EnquiryCounselorType[keyof typeof EnquiryCounselorType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnquiryCounselorType = {
  Undefined: 0,
  Assigned: 1,
  NotAssigned: 2,
} as const;

export interface EnquiryFeesStructure {
  totalFees?: number;
  firstInstallmentFees?: number;
  registrationFees?: number;
  finalFees?: number;
  /** @nullable */
  enquiryId?: string | null;
  year?: number;
  installment?: number;
  feesMaster?: IdNameModel;
  /** @nullable */
  feesTrans?: FeesTrans[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface EnquiryFeesStructureApiResponse {
  readonly executionTime?: number;
  result?: EnquiryFeesStructure;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EnquiryGroupBySource {
  rejected?: number;
  enrolled?: number;
  notInterested?: number;
}

export interface EnquiryListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: Enquiry[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EnquiryListRes {
  /** @nullable */
  counselorsData?: ApplicationUser[] | null;
  /** @nullable */
  enquiryNumber?: string | null;
  orderNumber?: number;
  /** @nullable */
  isReAdmission?: boolean | null;
  /** @nullable */
  reason?: string | null;
  isDefaultPassword?: boolean;
  /** @nullable */
  enrollmentNumber?: string | null;
  /** @nullable */
  aadharNumber?: string | null;
  /** @nullable */
  abcId?: string | null;
  /** @nullable */
  debId?: string | null;
  reject?: Reject;
  /** @nullable */
  bloodGroup?: string | null;
  processStep?: ProcessStepData;
  sno?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  middleName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  nationality?: string | null;
  zipcode?: number;
  /** @nullable */
  city?: string | null;
  state?: IndianState;
  /** @nullable */
  fatherName?: string | null;
  /** @nullable */
  motherName?: string | null;
  /** @nullable */
  fatherOccupation?: string | null;
  /** @nullable */
  motherOccupation?: string | null;
  cardNo?: number;
  userId?: string;
  /** @nullable */
  studentId?: string | null;
  biometricCode?: number;
  dateOfBirth?: string;
  enrolledDate?: string;
  enquiryDate?: string;
  gender?: IdNameModel;
  category?: IdNameModel;
  englishProficiency?: LanguageProficiency;
  currentPassOutYear?: number;
  /** @nullable */
  otherLanguages?: string | null;
  roleType?: RoleTypes;
  /** @nullable */
  currentSchoolName?: string | null;
  curriculum?: IdNameModel;
  stream?: IdNameModel;
  /** @nullable */
  otherInformation?: string | null;
  /** @nullable */
  reference?: string | null;
  approvalStatus?: IdNameModel;
  amount?: number;
  /** @nullable */
  referralSource?: string | null;
  signature?: Signature;
  counselorName?: IdNameModel;
  candidateImage?: FileNameModel;
  /** @nullable */
  academicRecord?: AcademicRecord[] | null;
  contactDetail?: ContactDetail;
  batch?: IdNameModel;
  medium?: IdNameModel;
  attendance?: AttendanceStatus;
  /** @nullable */
  credentials?: StudentCredentials[] | null;
  /** @nullable */
  attachments?: Attachment[] | null;
  currentClass?: IdNameModel;
  classStatus?: ClassStatus;
  /** @nullable */
  qualification?: string | null;
  counsellingSession?: boolean;
  mode?: EnquiryType;
  isIncomingCall?: boolean;
  enquiryCommunication?: EnquiryCommunication;
  sources?: IdNameModel;
  /** @nullable */
  assignTo?: IdNameModel[] | null;
  percentage?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  centerVisited?: CenterVisited;
  response?: Response;
  guardianState?: IndianState;
  /** @nullable */
  guardianCity?: string | null;
  /** @nullable */
  guardianName?: string | null;
  /** @nullable */
  guardianRelation?: string | null;
  guardianPhone?: number;
  /** @nullable */
  guardianOccupation?: string | null;
  /** @nullable */
  guardianAddress?: string | null;
  guardianZipCode?: number;
  /** @nullable */
  counselors?: IdNameModel[] | null;
  counselor?: IdNameModel;
  sameAsCandidateAddress?: boolean;
  isEnrolled?: boolean;
  /** @nullable */
  noteForWithoutFees?: string | null;
  isActive?: boolean;
  ecard?: Ecard;
  isDelete?: boolean;
  department?: IdNameModel;
  course?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  officialEmail?: string | null;
  /** @nullable */
  mentorName?: string | null;
  /** @nullable */
  centerCity?: string | null;
  registrationFees?: RegistrationFees;
  employeeReferral?: EmployeeReferral;
  classTenthDetail?: ClassTenthDetail;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface EnquiryListResPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: EnquiryListRes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface EnquiryListResPagedDataApiResponse {
  readonly executionTime?: number;
  result?: EnquiryListResPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface EnquiryPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: Enquiry[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface EnquiryPagedDataApiResponse {
  readonly executionTime?: number;
  result?: EnquiryPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type EnquiryType = typeof EnquiryType[keyof typeof EnquiryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnquiryType = {
  Undefined: 0,
  Website: 1,
  Application: 2,
} as const;

export type EntitiesEnum = typeof EntitiesEnum[keyof typeof EntitiesEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitiesEnum = {
  Unknown: 0,
  ApplicationUser: 1,
  Company: 2,
  Master: 3,
  WebsiteEnquiries: 4,
  Enquiry: 5,
  ProcessSteps: 6,
} as const;

export interface ExamPaperModel {
  /** @nullable */
  name?: string | null;
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  subject?: IdNameModel;
  /** @nullable */
  assessmentId?: string | null;
  timeLimit?: number;
  /** @nullable */
  questions?: Questions[] | null;
  examStudentCount?: ExamStudentCount;
  subjectDetail?: SubjectDetail;
  codeLanguage?: CodeLanguage;
  isStrictTime?: boolean;
  isCheckAttendance?: boolean;
  publishExamSheet?: PublishExamSheet;
  examType?: ExamType;
  examTemplate?: IdNameModel;
  isFinalDisplay?: boolean;
  isRestrictionEnabled?: boolean;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ExamPaperModelPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: ExamPaperModel[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface ExamPaperModelPagedDataApiResponse {
  readonly executionTime?: number;
  result?: ExamPaperModelPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ExamQueries {
  /** @nullable */
  remark?: string | null;
  /** @nullable */
  reason?: string | null;
  student?: IdNameModel;
  /** @nullable */
  answerSheetId?: string | null;
  answer?: StudentAnswers;
  approvedBy?: RecordUpdateInfo;
  status?: StatusEnum;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ExamQueriesApiResponse {
  readonly executionTime?: number;
  result?: ExamQueries;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ExamQueriesListRes {
  subject?: IdNameModel;
  exam?: IdNameModel;
  /** @nullable */
  assessmentName?: string | null;
  assessmentTeacher?: RecordUpdateInfo;
  department?: IdNameModel;
  batch?: IdNameModel;
  subjectDetails?: SubjectDetail;
  /** @nullable */
  remark?: string | null;
  /** @nullable */
  reason?: string | null;
  student?: IdNameModel;
  /** @nullable */
  answerSheetId?: string | null;
  answer?: StudentAnswers;
  approvedBy?: RecordUpdateInfo;
  status?: StatusEnum;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ExamQueriesListResPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: ExamQueriesListRes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface ExamQueriesListResPagedDataApiResponse {
  readonly executionTime?: number;
  result?: ExamQueriesListResPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ExamStudentCount {
  totalPresent?: number;
  totalAbsent?: number;
  totalStudent?: number;
}

export interface ExamToQuestionLookUp {
  /** @nullable */
  questionsDetails?: QuestionPaperRes[] | null;
  /** @nullable */
  name?: string | null;
  department?: IdNameModel;
  course?: IdNameModel;
  batch?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  subject?: IdNameModel;
  /** @nullable */
  assessmentId?: string | null;
  timeLimit?: number;
  /** @nullable */
  questions?: Questions[] | null;
  examStudentCount?: ExamStudentCount;
  subjectDetail?: SubjectDetail;
  codeLanguage?: CodeLanguage;
  isStrictTime?: boolean;
  isCheckAttendance?: boolean;
  publishExamSheet?: PublishExamSheet;
  examType?: ExamType;
  examTemplate?: IdNameModel;
  isFinalDisplay?: boolean;
  isRestrictionEnabled?: boolean;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ExamToQuestionLookUpApiResponse {
  readonly executionTime?: number;
  result?: ExamToQuestionLookUp;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type ExamType = typeof ExamType[keyof typeof ExamType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExamType = {
  Undefined: 0,
  Practical: 1,
  Viva: 2,
  Theory: 3,
} as const;

export interface FacultyDetailRes {
  /** @nullable */
  departments?: Master[] | null;
  /** @nullable */
  teachers?: Master[] | null;
}

export interface FacultyDetailResApiResponse {
  readonly executionTime?: number;
  result?: FacultyDetailRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface FacultyDetailsReq {
  /** @nullable */
  departmentId?: string | null;
  /** @nullable */
  teacherId?: string | null;
}

export interface FcmToken {
  /** @nullable */
  token?: string | null;
  medium?: LoginMedium;
}

export interface FeesMaster {
  fromDate?: string;
  /** @nullable */
  name?: string | null;
  totalFees?: number;
  firstInstallmentFees?: number;
  registrationFees?: number;
  finalFees?: number;
  course?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface FeesMasterApiResponse {
  readonly executionTime?: number;
  result?: FeesMaster;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface FeesMasterPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: FeesMaster[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface FeesMasterPagedDataApiResponse {
  readonly executionTime?: number;
  result?: FeesMasterPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface FeesTrans {
  /** @nullable */
  uniqueId?: string | null;
  date?: string;
  amount?: number;
  /** @nullable */
  name?: string | null;
  isPaid?: boolean;
}

export interface FileNameModel {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  contentType?: string | null;
  /** @nullable */
  length?: number | null;
  /** @nullable */
  path?: string | null;
}

export interface ForgetPassword {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  otp?: string | null;
}

export interface ForgotPasswordModel {
  /** @minLength 1 */
  email: string;
}

export interface FromToModel {
  from?: string;
  to?: string;
}

export interface GetAllDesignCourseDetailsRes {
  /** @nullable */
  departments?: Master[] | null;
  /** @nullable */
  courses?: Master[] | null;
  /** @nullable */
  schemas?: Master[] | null;
  /** @nullable */
  semesters?: Master[] | null;
  /** @nullable */
  subjects?: Master[] | null;
  /** @nullable */
  batches?: Master[] | null;
  /** @nullable */
  sections?: Master[] | null;
}

export interface GetAllDesignCourseDetailsResApiResponse {
  readonly executionTime?: number;
  result?: GetAllDesignCourseDetailsRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetAllMasterResponse {
  masterType?: MasterType;
  /** @nullable */
  items?: MasterSearchResponse[] | null;
}

export interface GetAllMasterResponsePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: GetAllMasterResponse[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface GetAllMasterResponsePagedDataApiResponse {
  readonly executionTime?: number;
  result?: GetAllMasterResponsePagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetCitMasterFieldRes {
  /** @nullable */
  gender?: GetCitMasterRes[] | null;
  /** @nullable */
  source?: GetCitMasterRes[] | null;
  /** @nullable */
  board?: GetCitMasterRes[] | null;
  /** @nullable */
  stream?: GetCitMasterRes[] | null;
  /** @nullable */
  medium?: GetCitMasterRes[] | null;
  /** @nullable */
  class?: GetCitMasterRes[] | null;
  /** @nullable */
  course?: GetCitMasterRes[] | null;
}

export interface GetCitMasterFieldResApiResponse {
  readonly executionTime?: number;
  result?: GetCitMasterFieldRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetCitMasterRes {
  type?: MasterType;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface GetExamIndividualStudentAnswerSheetRes {
  codeLanguage?: CodeLanguage;
  exam?: IdNameModel;
  student?: IdNameModel;
  subject?: IdNameModel;
  /** @nullable */
  assessmentId?: string | null;
  timeLimit?: number;
  subjectDetail?: SubjectDetail;
  /** @nullable */
  answers?: StudentAnswers[] | null;
  startTimeStamp?: string;
  sheetMarksStatus?: MarksStatus;
  resumeExam?: boolean;
  examType?: ExamType;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface GetExamIndividualStudentAnswerSheetResApiResponse {
  readonly executionTime?: number;
  result?: GetExamIndividualStudentAnswerSheetRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetFeesByIdRes {
  /** @nullable */
  feesTrans?: FeesTrans[] | null;
  /** @nullable */
  enquiryNumber?: string | null;
  orderNumber?: number;
  /** @nullable */
  isReAdmission?: boolean | null;
  /** @nullable */
  reason?: string | null;
  isDefaultPassword?: boolean;
  /** @nullable */
  enrollmentNumber?: string | null;
  /** @nullable */
  aadharNumber?: string | null;
  /** @nullable */
  abcId?: string | null;
  /** @nullable */
  debId?: string | null;
  reject?: Reject;
  /** @nullable */
  bloodGroup?: string | null;
  processStep?: ProcessStepData;
  sno?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  fullName?: string | null;
  /** @nullable */
  middleName?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  nationality?: string | null;
  zipcode?: number;
  /** @nullable */
  city?: string | null;
  state?: IndianState;
  /** @nullable */
  fatherName?: string | null;
  /** @nullable */
  motherName?: string | null;
  /** @nullable */
  fatherOccupation?: string | null;
  /** @nullable */
  motherOccupation?: string | null;
  cardNo?: number;
  userId?: string;
  /** @nullable */
  studentId?: string | null;
  biometricCode?: number;
  dateOfBirth?: string;
  enrolledDate?: string;
  enquiryDate?: string;
  gender?: IdNameModel;
  category?: IdNameModel;
  englishProficiency?: LanguageProficiency;
  currentPassOutYear?: number;
  /** @nullable */
  otherLanguages?: string | null;
  roleType?: RoleTypes;
  /** @nullable */
  currentSchoolName?: string | null;
  curriculum?: IdNameModel;
  stream?: IdNameModel;
  /** @nullable */
  otherInformation?: string | null;
  /** @nullable */
  reference?: string | null;
  approvalStatus?: IdNameModel;
  amount?: number;
  /** @nullable */
  referralSource?: string | null;
  signature?: Signature;
  counselorName?: IdNameModel;
  candidateImage?: FileNameModel;
  /** @nullable */
  academicRecord?: AcademicRecord[] | null;
  contactDetail?: ContactDetail;
  batch?: IdNameModel;
  medium?: IdNameModel;
  attendance?: AttendanceStatus;
  /** @nullable */
  credentials?: StudentCredentials[] | null;
  /** @nullable */
  attachments?: Attachment[] | null;
  currentClass?: IdNameModel;
  classStatus?: ClassStatus;
  /** @nullable */
  qualification?: string | null;
  counsellingSession?: boolean;
  mode?: EnquiryType;
  isIncomingCall?: boolean;
  enquiryCommunication?: EnquiryCommunication;
  sources?: IdNameModel;
  /** @nullable */
  assignTo?: IdNameModel[] | null;
  percentage?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  centerVisited?: CenterVisited;
  response?: Response;
  guardianState?: IndianState;
  /** @nullable */
  guardianCity?: string | null;
  /** @nullable */
  guardianName?: string | null;
  /** @nullable */
  guardianRelation?: string | null;
  guardianPhone?: number;
  /** @nullable */
  guardianOccupation?: string | null;
  /** @nullable */
  guardianAddress?: string | null;
  guardianZipCode?: number;
  /** @nullable */
  counselors?: IdNameModel[] | null;
  counselor?: IdNameModel;
  sameAsCandidateAddress?: boolean;
  isEnrolled?: boolean;
  /** @nullable */
  noteForWithoutFees?: string | null;
  isActive?: boolean;
  ecard?: Ecard;
  isDelete?: boolean;
  department?: IdNameModel;
  course?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
  /** @nullable */
  officialEmail?: string | null;
  /** @nullable */
  mentorName?: string | null;
  /** @nullable */
  centerCity?: string | null;
  registrationFees?: RegistrationFees;
  employeeReferral?: EmployeeReferral;
  classTenthDetail?: ClassTenthDetail;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface GetFeesByIdResApiResponse {
  readonly executionTime?: number;
  result?: GetFeesByIdRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetListPaymentRes {
  guardianPhone?: number;
  student?: IdNameModel;
  /** @nullable */
  paymentDetail?: PaymentDetail[] | null;
  totalPaidAmount?: number;
  sno?: number;
  feesAmount?: number;
  remainingAmount?: number;
  stream?: IdNameModel;
  batch?: IdNameModel;
  totalRefundable?: number;
  totalPaidToParul?: number;
  totalCITAmount?: number;
  totalPaidToParulCIT?: number;
  /** @nullable */
  attachments?: PaymentsImage[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface GetListPaymentResPaymentGraphDataPagedData {
  total?: PaymentGraphData;
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: GetListPaymentRes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface GetListPaymentResPaymentGraphDataPagedDataGetListPaymentRespose {
  data?: GetListPaymentResPaymentGraphDataPagedData;
  grandTotalFees?: PaymentGraphData;
}

export interface GetListPaymentResPaymentGraphDataPagedDataGetListPaymentResposeApiResponse {
  readonly executionTime?: number;
  result?: GetListPaymentResPaymentGraphDataPagedDataGetListPaymentRespose;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetOrderDetailRes {
  enquiry?: Enquiry;
  student?: IdNameModel;
  orderId?: number;
  amount?: number;
  paymentType?: PaymentType;
  /** @nullable */
  uniqueId?: string[] | null;
  expiry?: string;
  orderStatus?: HdfcOrderStatus;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface GetOrderDetailResListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: GetOrderDetailRes[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GetSubjectAllocationRes {
  section?: IdNameModel;
  semester?: IdNameModel;
  subject?: IdNameModel;
  department?: IdNameModel;
  course?: IdNameModel;
  schema?: IdNameModel;
  batch?: IdNameModel;
  teacher?: IdNameModel;
  /** @nullable */
  details?: Details[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface GetSubjectAllocationResPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: GetSubjectAllocationRes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface GetSubjectAllocationResPagedDataApiResponse {
  readonly executionTime?: number;
  result?: GetSubjectAllocationResPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface GradePoints {
  /** @nullable */
  pointDescription?: string | null;
  /** @nullable */
  pointFeedback?: string | null;
  /** @nullable */
  pointTitle?: string | null;
}

export interface GradeScale {
  /** @nullable */
  min?: string | null;
  /** @nullable */
  max?: string | null;
  /** @nullable */
  grades?: string | null;
  /** @nullable */
  gpa?: string | null;
}

export interface HDFCOrder {
  student?: IdNameModel;
  orderId?: number;
  amount?: number;
  paymentType?: PaymentType;
  /** @nullable */
  uniqueId?: string[] | null;
  expiry?: string;
  orderStatus?: HdfcOrderStatus;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface HDFCOrderPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: HDFCOrder[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface HDFCOrderPagedDataApiResponse {
  readonly executionTime?: number;
  result?: HDFCOrderPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type HdfcOrderStatus = typeof HdfcOrderStatus[keyof typeof HdfcOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HdfcOrderStatus = {
  Undefined: 0,
  Pending: 1,
  Success: 2,
  Failed: 3,
  InProgress: 4,
} as const;

export interface HolidaysImage {
  fileName?: FileNameModel;
  updateInfo?: RecordUpdateInfo;
}

export interface IdModel {
  /** @nullable */
  id?: string | null;
}

export interface IdNameBool {
  isAttachmentRequired?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface IdNameModel {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface IdNameModelListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: IdNameModel[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface IdNameModelPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: IdNameModel[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface IdNameModelPagedDataApiResponse {
  readonly executionTime?: number;
  result?: IdNameModelPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface IdNameWeight {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  weight?: number;
}

export interface IdNameWithNumber {
  id?: string;
  /** @nullable */
  name?: string | null;
  phone?: number;
  /** @nullable */
  call?: string | null;
}

export interface IdNameWithNumberPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: IdNameWithNumber[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface IdNameWithNumberPagedDataApiResponse {
  readonly executionTime?: number;
  result?: IdNameWithNumberPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface IdNameePresent {
  isPresent?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface ImageVerificationRequest {
  /** @nullable */
  imageUrl?: string | null;
  /** @nullable */
  base64String?: string | null;
}

export interface ImageVerificationResponse {
  status?: boolean;
  /** @nullable */
  message?: string | null;
}

export interface ImageVerificationResponseApiResponse {
  readonly executionTime?: number;
  result?: ImageVerificationResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type IndianState = typeof IndianState[keyof typeof IndianState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IndianState = {
  None: 0,
  AndamanAndNicobarIslands: 1,
  AndhraPradesh: 2,
  ArunachalPradesh: 3,
  Assam: 4,
  Bihar: 5,
  Chandigarh: 6,
  Chhattisgarh: 7,
  DadraAndNagarHaveli: 8,
  DamanAndDiu: 9,
  Delhi: 10,
  Goa: 11,
  Gujarat: 12,
  Haryana: 13,
  HimachalPradesh: 14,
  JammuAndKashmir: 15,
  Jharkhand: 16,
  Karnataka: 17,
  Kerala: 18,
  Lakshadweep: 19,
  MadhyaPradesh: 20,
  Maharashtra: 21,
  Manipur: 22,
  Meghalaya: 23,
  Mizoram: 24,
  Nagaland: 25,
  Odisha: 26,
  Puducherry: 27,
  Punjab: 28,
  Rajasthan: 29,
  Sikkim: 30,
  TamilNadu: 31,
  Telangana: 32,
  Tripura: 33,
  UttarPradesh: 34,
  Uttarakhand: 35,
  WestBengal: 36,
} as const;

export type LanguageProficiency = typeof LanguageProficiency[keyof typeof LanguageProficiency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LanguageProficiency = {
  Beginner: 0,
  Intermediate: 1,
  Advanced: 2,
} as const;

export interface LeaveModel {
  status?: LeaveStatusEnum;
  /** @nullable */
  remark?: string | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export type LeaveStatusEnum = typeof LeaveStatusEnum[keyof typeof LeaveStatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeaveStatusEnum = {
  Pending: 0,
  Approved: 1,
  Cancelled: 2,
  Rejected: 3,
} as const;

export interface LeaveTypes {
  /** @nullable */
  leaveType?: string | null;
  isAttachmentRequired?: boolean;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface LeaveTypesApiResponse {
  readonly executionTime?: number;
  result?: LeaveTypes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface LeaveTypesListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: LeaveTypes[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface LeaveTypesPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: LeaveTypes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface LeaveTypesPagedDataApiResponse {
  readonly executionTime?: number;
  result?: LeaveTypesPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type LoginMedium = typeof LoginMedium[keyof typeof LoginMedium];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginMedium = {
  Android: 1,
  Ios: 2,
} as const;

export interface ManualAttDetail {
  student?: StudentSubmitRes;
  type?: AttendanceStatus;
}

export interface ManualEntryModel {
  /** @nullable */
  students?: ManualAttDetail[] | null;
  entryDate?: string;
  /** @nullable */
  batchId?: string | null;
}

export interface ManualEntryModelApiResponse {
  readonly executionTime?: number;
  result?: ManualEntryModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type MarksStatus = typeof MarksStatus[keyof typeof MarksStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarksStatus = {
  Undefined: 0,
  Pending: 1,
  Marked: 2,
} as const;

export interface Master {
  masterType?: MasterType;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  code?: string | null;
  sno?: number;
  department?: IdNameModel;
  course?: IdNameModel;
  schema?: IdNameModel;
  session?: IdNameModel;
  section?: IdNameModel;
  currentSchema?: IdNameModel;
  semester?: IdNameModel;
  subjectTypes?: IdNameModel;
  /** @nullable */
  description?: string | null;
  feesTypeWebEnum?: PaymentType;
  showOnWebEnquiry?: boolean;
  isBankPayment?: boolean;
  isActive?: boolean;
  fromTo?: FromToModel;
  /** @nullable */
  attachments?: HolidaysImage[] | null;
  isDefaultFilter?: boolean;
  subjectType?: SubjectType;
  /** @nullable */
  units?: Units[] | null;
  /** @nullable */
  subjects?: IdNameModel[] | null;
  /** @nullable */
  alias?: string | null;
  /** @nullable */
  schemas?: Schema[] | null;
  credit?: number;
  cgpa?: number;
  /** @nullable */
  gradesValues?: GradeScale[] | null;
  /** @nullable */
  punchInTime?: string | null;
  /** @nullable */
  punchOutTime?: string | null;
  /** @nullable */
  batchDays?: BatchDaysModel[] | null;
  isLunchCal?: boolean;
  lunchTime?: number;
  amount?: number;
  courseRef?: IdNameModel;
  isAllowed?: boolean;
  currentSemester?: IdNameModel;
  /** @nullable */
  time?: string | null;
  reminderTiming?: ReminderTiming;
  /** @nullable */
  htmlContent?: string | null;
  /** @nullable */
  subject?: string | null;
  limit?: number;
  duration?: FromToModel;
  /** @nullable */
  rubricPoint?: Rubric[] | null;
  allowDocumentsFor?: AllowDocumentsFor;
  /** @nullable */
  employeeId?: string | null;
  teacher?: IdNameModel;
  batch?: IdNameModel;
  isDeleted?: boolean;
  isRefundable?: boolean;
  isPaidToParul?: boolean;
  joiningDate?: string;
  /** @nullable */
  teacherEmpId?: string | null;
  facultyType?: IdNameModel;
  selectedProcessStep?: ProcessStepsEnum;
  designCourseIds?: DesignCourseIds;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface MasterApiResponse {
  readonly executionTime?: number;
  result?: Master;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface MasterListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: Master[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface MasterPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: Master[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface MasterPagedDataApiResponse {
  readonly executionTime?: number;
  result?: MasterPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface MasterSearchResponse {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
}

export interface MasterSearchResponsePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: MasterSearchResponse[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface MasterSearchResponsePagedDataApiResponse {
  readonly executionTime?: number;
  result?: MasterSearchResponsePagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type MasterType = typeof MasterType[keyof typeof MasterType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MasterType = {
  Unknown: 0,
  Gender: 1,
  Category: 2,
  Curriculum: 3,
  Stream: 4,
  Classes: 5,
  PaymentMethod: 6,
  Credential: 7,
  Batch: 8,
  Documents: 9,
  Holidays: 10,
  Status: 11,
  Medium: 12,
  Course: 13,
  Subject: 14,
  Semester: 15,
  Department: 16,
  Role: 17,
  FeesType: 18,
  Counselor: 19,
  Source: 20,
  AssignTo: 21,
  Reason: 22,
  Platform: 23,
  Reminder: 24,
  Task: 25,
  MailTemplates: 26,
  Session: 27,
  Room: 28,
  Schema: 29,
  Section: 30,
  AssessmentCategory: 31,
  GradeScale: 32,
  FacultyMapWithDept: 33,
  Rubric: 34,
  SubjectTypes: 35,
  MandatoryDocumentType: 36,
  Notice: 37,
  FacultyType: 38,
  Shift: 39,
  EmployeeReferral: 40,
  ExamInstructionsTemplate: 41,
  Notification: 42,
} as const;

export type MeetingType = typeof MeetingType[keyof typeof MeetingType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingType = {
  Unknown: 0,
  Online: 1,
  Offline: 2,
} as const;

export interface MongoDBRef {
  /** @nullable */
  databaseName?: string | null;
  /** @nullable */
  collectionName?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface MonthlyCallLogReportRes {
  id?: string;
  totalCalls?: number;
  sameDayCalls?: number;
  dueCalls?: number;
  lastDayDueCalls?: number;
  /** @nullable */
  callDetails?: NameNumber[] | null;
}

export interface MonthlyCallLogReportResListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: MonthlyCallLogReportRes[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface MonthlyReportModel {
  studentIdName?: IdNameModel;
  /** @nullable */
  studentId?: string | null;
  totalPresentDays?: number;
  totalAbsentDays?: number;
  totalLeaves?: number;
  totalHolidays?: number;
  totalWorkingDays?: number;
  totalWeekOffs?: number;
  lateCheckinDays?: number;
  earlyCheckoutDays?: number;
  requiredMin?: number;
  studyMin?: number;
  extraMin?: number;
  shortMin?: number;
}

export interface MonthlyReportModelListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: MonthlyReportModel[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface NameModel {
  /** @nullable */
  title?: string | null;
  /**
   * @minLength 2
   * @maxLength 150
   * @nullable
   */
  first?: string | null;
  /**
   * @minLength 0
   * @maxLength 150
   * @nullable
   */
  last?: string | null;
  /** @nullable */
  alias?: string | null;
}

export interface NameNumber {
  number?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface NotApprovedItem {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface NoticeListRes {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  attachments?: HolidaysImage[] | null;
  createdAt?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
  designCourseIds?: DesignCourseIds;
  recordStatus?: RecordStatusType;
}

export interface NoticeListResListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: NoticeListRes[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

/**
 * @nullable
 */
export type ObjectApiResponseResult = unknown | null;

export interface ObjectApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: ObjectApiResponseResult;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type OutcomeType = typeof OutcomeType[keyof typeof OutcomeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutcomeType = {
  Unknown: 0,
  Interested: 1,
  LeftMessage: 2,
  NoResponse: 3,
  Notabletoreach: 4,
  DNC: 5,
  Pending: 6,
  Done: 7,
} as const;

export type PaidByEnum = typeof PaidByEnum[keyof typeof PaidByEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaidByEnum = {
  CIT: 0,
  Student: 1,
} as const;

export interface Payment {
  student?: IdNameModel;
  /** @nullable */
  paymentDetail?: PaymentDetail[] | null;
  totalPaidAmount?: number;
  sno?: number;
  feesAmount?: number;
  remainingAmount?: number;
  stream?: IdNameModel;
  batch?: IdNameModel;
  totalRefundable?: number;
  totalPaidToParul?: number;
  totalCITAmount?: number;
  totalPaidToParulCIT?: number;
  /** @nullable */
  attachments?: PaymentsImage[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface PaymentApiResponse {
  readonly executionTime?: number;
  result?: Payment;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PaymentApproval {
  student?: IdNameModel;
  orderId?: number;
  amount?: number;
  paymentType?: PaymentType;
  /** @nullable */
  uniqueId?: string[] | null;
  paymentStatus?: HdfcOrderStatus;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface PaymentApprovalPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: PaymentApproval[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface PaymentApprovalPagedDataApiResponse {
  readonly executionTime?: number;
  result?: PaymentApprovalPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PaymentApprovalRequest {
  /** @nullable */
  paymentApprovalId?: string | null;
  paymentStatus?: HdfcOrderStatus;
  /** @nullable */
  id?: string | null;
  index?: number;
  student?: IdNameModel;
  stream?: IdNameModel;
  batch?: IdNameModel;
  isRefundable?: boolean;
  isPaidToParul?: boolean;
  paidBy?: PaidByEnum;
  date?: string;
  medium?: IdNameModel;
  /** @nullable */
  mediumDetails?: string | null;
  amount?: number;
  fileName?: FileNameModel;
  feesType?: IdNameModel;
  /** @nullable */
  transactionId?: string | null;
  autoNumber?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  isRefundAmount?: boolean;
  isPaidToParulAmount?: boolean;
  /** @nullable */
  attachments?: PaymentsImage[] | null;
  isDeleted?: boolean;
}

export interface PaymentDetail {
  date?: string;
  medium?: IdNameModel;
  /** @nullable */
  mediumDetails?: string | null;
  amount?: number;
  fileName?: FileNameModel;
  feesType?: IdNameModel;
  /** @nullable */
  transactionId?: string | null;
  autoNumber?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  stream?: IdNameModel;
  batch?: IdNameModel;
  isRefundAmount?: boolean;
  isPaidToParulAmount?: boolean;
  /** @nullable */
  attachments?: PaymentsImage[] | null;
  paidBy?: PaidByEnum;
  isDeleted?: boolean;
}

export interface PaymentGraphData {
  totalFeesAmount?: number;
  totalPaidAmount?: number;
  totalRemainingAmount?: number;
  totalRefundAmount?: number;
  totalPaidToParulCIT?: number;
  totalPaidToParul?: number;
  totalCITAmount?: number;
}

export interface PaymentLinkReq {
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  paymentId?: string[] | null;
  paymentType?: PaymentType;
}

export interface PaymentListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: Payment[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PaymentRequest {
  /** @nullable */
  id?: string | null;
  index?: number;
  student?: IdNameModel;
  stream?: IdNameModel;
  batch?: IdNameModel;
  isRefundable?: boolean;
  isPaidToParul?: boolean;
  paidBy?: PaidByEnum;
  date?: string;
  medium?: IdNameModel;
  /** @nullable */
  mediumDetails?: string | null;
  amount?: number;
  fileName?: FileNameModel;
  feesType?: IdNameModel;
  /** @nullable */
  transactionId?: string | null;
  autoNumber?: number;
  /** @nullable */
  incrementalSeries?: string | null;
  isRefundAmount?: boolean;
  isPaidToParulAmount?: boolean;
  /** @nullable */
  attachments?: PaymentsImage[] | null;
  isDeleted?: boolean;
}

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentType = {
  Undefined: 0,
  Enrollment: 1,
  Admission: 2,
  University: 3,
} as const;

export interface PaymentsImage {
  fileName?: FileNameModel;
  updateInfo?: RecordUpdateInfo;
}

export type PeriodTypeEnum = typeof PeriodTypeEnum[keyof typeof PeriodTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PeriodTypeEnum = {
  Period: 0,
  Break: 1,
} as const;

export interface PrivacyPolicy {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  body?: string | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface PrivacyPolicyApiResponse {
  readonly executionTime?: number;
  result?: PrivacyPolicy;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PrivacyPolicyListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: PrivacyPolicy[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PrivacyPolicyPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: PrivacyPolicy[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface PrivacyPolicyPagedDataApiResponse {
  readonly executionTime?: number;
  result?: PrivacyPolicyPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ProcessStepData {
  processStep?: ProcessStepsEnum;
  subSteps?: number;
  hasSubSteps?: boolean;
  updatedBy?: RecordUpdateInfo;
}

export interface ProcessStepRequestModel {
  /** @nullable */
  id?: string | null;
  date?: string;
  dateType?: DateType;
  isEnrolled?: boolean;
  /** @nullable */
  noteForWithoutFees?: string | null;
  processStep?: ProcessStepsEnum;
  subSteps?: number;
  hasSubSteps?: boolean;
  updatedBy?: RecordUpdateInfo;
}

export interface ProcessStepRequestModelApiResponse {
  readonly executionTime?: number;
  result?: ProcessStepRequestModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ProcessStepStage {
  outerStage?: Stage;
  innerStage?: Stage;
}

export interface ProcessSteps {
  sno?: number;
  /** @nullable */
  name?: string | null;
  orderNumber?: number;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  color?: string | null;
  remarkDrawer?: boolean;
  /** @nullable */
  steps?: Step[] | null;
  nowIsStudent?: boolean;
  processType?: EnquiryType;
  currentStage?: ProcessStepStage;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ProcessStepsApiResponse {
  readonly executionTime?: number;
  result?: ProcessSteps;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type ProcessStepsEnum = typeof ProcessStepsEnum[keyof typeof ProcessStepsEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessStepsEnum = {
  Undefined: 0,
  Website: 1,
  New: 2,
  Counseling: 3,
  Registration: 4,
  Documents: 5,
  EmailInvoice: 6,
  Verification: 7,
  LSBU: 8,
  Enroll: 9,
} as const;

export interface ProcessStepsPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: ProcessSteps[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface ProcessStepsPagedDataApiResponse {
  readonly executionTime?: number;
  result?: ProcessStepsPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface PublishExamSheet {
  isPublishSheet?: RecordStatusType;
  from?: string;
  to?: string;
}

export interface QuestionAnswerModel {
  /** @nullable */
  questionId?: string | null;
  /** @nullable */
  studentAnswer?: string | null;
}

export interface QuestionIdMark {
  /** @nullable */
  id?: string | null;
  marks?: number;
}

export interface QuestionPaperRes {
  key?: number;
  /** @nullable */
  questionLabel?: string | null;
  questionsType?: QuestionsType;
  questionMarks?: number;
  /** @nullable */
  options?: QuestionsPaperOptions[] | null;
  /** @nullable */
  correctAnswer?: string | null;
  subject?: IdNameModel;
  semester?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface Questions {
  key?: number;
  /** @nullable */
  questionId?: string | null;
  marks?: number;
}

export interface QuestionsPaperOptions {
  /** @nullable */
  uuId?: string | null;
  /** @nullable */
  label?: string | null;
  isCorrect?: boolean;
}

export type QuestionsType = typeof QuestionsType[keyof typeof QuestionsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestionsType = {
  Undefined: 0,
  MCQ: 1,
  LongAnswer: 2,
  Program: 3,
} as const;

export type RecordStatusType = typeof RecordStatusType[keyof typeof RecordStatusType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordStatusType = {
  Undefined: 0,
  Drafted: 1,
  Published: 2,
  Deleted: 3,
  Approved: 4,
  Pending: 5,
} as const;

export interface RecordUpdateInfo {
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  userName?: string | null;
  date?: string;
}

export interface RegistrationFees {
  amount?: number;
  isPaid?: boolean;
}

export interface RegistrationPaymentLinkReq {
  /** @nullable */
  enquiryNumber?: string | null;
  amount?: number;
}

export interface Reject {
  processStep?: ProcessStepsEnum;
  reason?: IdNameModel;
  /** @nullable */
  note?: string | null;
}

export interface RejectApiResponse {
  readonly executionTime?: number;
  result?: Reject;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface RejectEnquiryClass {
  status?: boolean;
  /** @nullable */
  reason?: string | null;
  rejectedBy?: RecordUpdateInfo;
}

export interface RejectEnquiryClassApiResponse {
  readonly executionTime?: number;
  result?: RejectEnquiryClass;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface RejectEnquiryReq {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  reason?: string | null;
  reject?: boolean;
}

export interface RejectRequestModel {
  /** @nullable */
  id?: string | null;
  processStep?: ProcessStepsEnum;
  reason?: IdNameModel;
  /** @nullable */
  note?: string | null;
}

export type ReminderTiming = typeof ReminderTiming[keyof typeof ReminderTiming];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReminderTiming = {
  Undefined: 0,
  Before: 1,
  After: 2,
} as const;

export type Response = typeof Response[keyof typeof Response];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Response = {
  Undefined: 0,
  Interest: 1,
  NotInterest: 2,
  Dnp: 3,
  Followup: 4,
} as const;

export interface ResultByDesignCourseRes {
  /** @nullable */
  students?: IdNameModel[] | null;
  /** @nullable */
  category?: IdNameModel[] | null;
  /** @nullable */
  assessmentSubjectDetails?: SubjectAndAssessmentLookUp[] | null;
}

export interface ResultByDesignCourseResApiResponse {
  readonly executionTime?: number;
  result?: ResultByDesignCourseRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface Rights {
  /** @nullable */
  enquiries?: string | null;
  /** @nullable */
  students?: string | null;
  /** @nullable */
  curriculums?: string | null;
  /** @nullable */
  streams?: string | null;
  /** @nullable */
  classes?: string | null;
  /** @nullable */
  paymentMedium?: string | null;
  /** @nullable */
  credentials?: string | null;
  /** @nullable */
  documents?: string | null;
  /** @nullable */
  holidays?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  medium?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  attendance?: string | null;
  /** @nullable */
  fees?: string | null;
  /** @nullable */
  settings?: string | null;
  /** @nullable */
  feesType?: string | null;
  /** @nullable */
  counselor?: string | null;
  /** @nullable */
  lms?: string | null;
  /** @nullable */
  assessment?: string | null;
  /** @nullable */
  request?: string | null;
  /** @nullable */
  reports?: string | null;
  /** @nullable */
  callLogs?: string | null;
  /** @nullable */
  gradeBook?: string | null;
}

export type RoleTypes = typeof RoleTypes[keyof typeof RoleTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleTypes = {
  Undefined: 0,
  Admin: 1,
  Student: 2,
  Counsellor: 3,
  Mentor: 4,
  Accountant: 5,
  Teacher: 6,
  SuperAdmin: 7,
} as const;

export interface Rubric {
  criteria?: TitDes;
  /** @nullable */
  gradingScale?: GradePoints[] | null;
}

export interface SaveAnswerSheetForStudentExam {
  exam?: ExamToQuestionLookUp;
  studentAnswerSheet?: StudentAnswerSheet;
}

export interface SaveAnswerSheetForStudentExamApiResponse {
  readonly executionTime?: number;
  result?: SaveAnswerSheetForStudentExam;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SaveBioMatricReq {
  /** @nullable */
  machineTitle?: string | null;
  /** @nullable */
  machineCode?: string | null;
  /** @nullable */
  studentIds?: IdModel[] | null;
  actionBioType?: ActionBioType;
}

export interface SaveStudentMarksReq {
  /** @nullable */
  answerSheetId?: string | null;
  /** @nullable */
  questions?: QuestionIdMark[] | null;
  /** @nullable */
  assessmentId?: string | null;
  /** @nullable */
  student?: SubjectMarksDetails[] | null;
  examType?: ExamType;
}

export type ScheduleCategory = typeof ScheduleCategory[keyof typeof ScheduleCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduleCategory = {
  Undefined: 0,
  ClassSchedule: 1,
  ExamSchedule: 2,
  GeneralSchedule: 3,
  BreakTime: 4,
} as const;

export interface ScheduleGroupedData {
  /** @nullable */
  workDay?: string | null;
  /** @nullable */
  items?: ScheduleItemsList[] | null;
}

export interface ScheduleGroupedDataListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: ScheduleGroupedData[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ScheduleItemsList {
  schedule?: IdNameModel;
  section?: IdNameModel;
  type?: PeriodTypeEnum;
  /** @nullable */
  workDay?: string | null;
  startTime?: string;
  endTime?: string;
  subject?: IdNameModel;
  /** @nullable */
  title?: string | null;
  primaryTeacher?: IdNameModel;
  room?: IdNameModel;
  semester?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface ScheduleItemsListApiResponse {
  readonly executionTime?: number;
  result?: ScheduleItemsList;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface ScheduleItemsListUpdateResponse {
  /** @nullable */
  workDay?: string[] | null;
  startTime?: string;
  endTime?: string;
  subject?: IdNameModel;
  /** @nullable */
  title?: string | null;
  primaryTeacher?: IdNameModel;
  room?: IdNameModel;
}

export interface Schema {
  /** @nullable */
  id?: string | null;
  fromTo?: FromToModel;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  semesters?: IdNameModel[] | null;
  /** @nullable */
  description?: string | null;
}

export interface SchemaResponse {
  sno?: number;
  schemas?: Schema;
  currentSchema?: IdNameModel;
}

export interface SchemaResponsePagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: SchemaResponse[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface SchemaResponsePagedDataApiResponse {
  readonly executionTime?: number;
  result?: SchemaResponsePagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SectionDetailRes {
  /** @nullable */
  departments?: Master[] | null;
  /** @nullable */
  courses?: Master[] | null;
  /** @nullable */
  batches?: Master[] | null;
  /** @nullable */
  sections?: Master[] | null;
  /** @nullable */
  semesters?: Master[] | null;
}

export interface SectionDetailResApiResponse {
  readonly executionTime?: number;
  result?: SectionDetailRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SectionDetailsReq {
  /** @nullable */
  departmentId?: string | null;
  /** @nullable */
  courseId?: string | null;
  /** @nullable */
  batchId?: string | null;
  /** @nullable */
  sectionsId?: string | null;
}

export interface SendEamilInvoiceRequestModel {
  /** @nullable */
  enquiryId?: string | null;
  /** @nullable */
  to?: string | null;
  /** @nullable */
  cc?: IdNameModel[] | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  body?: string | null;
  /** @nullable */
  attachments?: Attachment[] | null;
  sender?: RecordUpdateInfo;
}

export interface SendEamilInvoiceRequestModelApiResponse {
  readonly executionTime?: number;
  result?: SendEamilInvoiceRequestModel;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SessionBreak {
  /** @nullable */
  breakTitle?: string | null;
  time?: FromToModel;
}

export interface Signature {
  counselor?: FileNameModel;
  candidate?: FileNameModel;
}

export interface SourceGroupModel {
  sources?: IdNameModel;
  count?: number;
}

export interface Stage {
  /** @nullable */
  id?: string | null;
  orderNumber?: number;
}

export interface StartEndTime {
  periodType?: PeriodTypeEnum;
  /** @nullable */
  description?: string | null;
  startTime?: string;
  endTime?: string;
}

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusEnum = {
  Undefined: 0,
  Pending: 1,
  Approved: 2,
  Cancelled: 3,
  Rejected: 4,
} as const;

export interface Step {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  orderNumber?: number;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  color?: string | null;
  remarkDrawer?: boolean;
}

export interface StreamGroupModel {
  stream?: IdNameModel;
  count?: number;
}

export interface StringApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: string | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentAnswerSheet {
  exam?: IdNameModel;
  student?: IdNameModel;
  subject?: IdNameModel;
  /** @nullable */
  assessmentId?: string | null;
  timeLimit?: number;
  subjectDetail?: SubjectDetail;
  /** @nullable */
  answers?: StudentAnswers[] | null;
  startTimeStamp?: string;
  sheetMarksStatus?: MarksStatus;
  resumeExam?: boolean;
  examType?: ExamType;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface StudentAnswerSheetPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: StudentAnswerSheet[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface StudentAnswerSheetPagedDataApiResponse {
  readonly executionTime?: number;
  result?: StudentAnswerSheetPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentAnswers {
  obtainedMarks?: number;
  marksStatus?: MarksStatus;
  /** @nullable */
  studentAnswer?: string | null;
  key?: number;
  /** @nullable */
  questionLabel?: string | null;
  questionsType?: QuestionsType;
  questionMarks?: number;
  /** @nullable */
  options?: QuestionsPaperOptions[] | null;
  /** @nullable */
  correctAnswer?: string | null;
  subject?: IdNameModel;
  semester?: IdNameModel;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface StudentAttReports {
  studentIdName?: IdNameModel;
  /** @nullable */
  studentId?: string | null;
  totalPresentDays?: number;
  totalAbsentDays?: number;
  totalLeaves?: number;
  totalHolidays?: number;
  totalWorkingDays?: number;
  totalWeekOffs?: number;
  lateCheckinDays?: number;
  earlyCheckoutDays?: number;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface StudentAttReportsListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentAttReports[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentAttendanceResponse {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  studentId?: string | null;
  batch?: IdNameModel;
  enrolledDate?: string;
  isLeave?: boolean;
  isHoliday?: boolean;
  /** @nullable */
  records?: AttendanceRecord[] | null;
}

export interface StudentAttendanceResponseListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentAttendanceResponse[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentCredentials {
  credentialName?: IdNameModel;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  password?: string | null;
  /** @nullable */
  number?: string | null;
  /** @nullable */
  detail?: string | null;
}

export interface StudentCredentialsListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentCredentials[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentDesignCourse {
  course?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
}

export interface StudentDetailAtt {
  image?: FileNameModel;
  contactDetail?: ContactDetail;
  enquiryDate?: string;
  enrolledDate?: string;
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface StudentEcardList {
  student?: IdNameModel;
  ecard?: Ecard;
  biometricCode?: number;
}

export interface StudentEcardListListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentEcardList[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type StudentExist = typeof StudentExist[keyof typeof StudentExist];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudentExist = {
  All: 0,
  Active: 1,
  InActive: 2,
  Readmission: 3,
} as const;

export interface StudentIDCardDetails {
  profile?: FileNameModel;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  courseName?: string | null;
  /** @nullable */
  batchName?: string | null;
  /** @nullable */
  studentId?: string | null;
  dob?: string;
  contactDetail?: ContactDetail;
  guardianPhone?: number;
}

export interface StudentIDCardDetailsListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentIDCardDetails[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentListResponse {
  batch?: IdNameModel;
  /** @nullable */
  students?: IdNameePresent[] | null;
}

export interface StudentListResponseApiResponse {
  readonly executionTime?: number;
  result?: StudentListResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentMonthlyAttendance {
  enrolledDate?: string;
  timeSchedule?: TimeSchedule;
  /** @nullable */
  attendances?: Attendance[] | null;
  totalPresent?: number;
  totalAbsent?: number;
  totalLeave?: number;
  totalHolidays?: number;
  totalWeekOffs?: number;
  /** @nullable */
  leaveType?: string | null;
  student?: StudentDetailAtt;
}

export interface StudentMonthlyAttendanceApiResponse {
  readonly executionTime?: number;
  result?: StudentMonthlyAttendance;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentMonthlyAttendanceForApp {
  enrolledDate?: string;
  batchDetail?: TimeSchedule;
  /** @nullable */
  attendances?: Attendance[] | null;
  /** @nullable */
  leaveType?: string | null;
  studentIdName?: IdNameModel;
  /** @nullable */
  studentId?: string | null;
  totalPresentDays?: number;
  totalAbsentDays?: number;
  totalLeaves?: number;
  totalHolidays?: number;
  totalWorkingDays?: number;
  totalWeekOffs?: number;
  lateCheckinDays?: number;
  earlyCheckoutDays?: number;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface StudentMonthlyAttendanceForAppApiResponse {
  readonly executionTime?: number;
  result?: StudentMonthlyAttendanceForApp;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentMonthlyAttendanceSummary {
  totalMonthDays?: number;
  totalPresent?: number;
  totalAbsent?: number;
  totalLeave?: number;
  totalHolidays?: number;
  totalWeekOffs?: number;
  monthlyPercentage?: number;
  /** @nullable */
  month?: string | null;
  presentPercentage?: number;
}

export interface StudentMonthlyAttendanceSummaryListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentMonthlyAttendanceSummary[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentSubmitRes {
  /** @nullable */
  studentId?: string | null;
  candidateImage?: FileNameModel;
  isPresent?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface StudentSubmitResListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: StudentSubmitRes[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface StudentYearlyAttReportRes {
  /** @nullable */
  attSummery?: StudentMonthlyAttendanceSummary[] | null;
  totalPresentPercentage?: number;
}

export interface StudentYearlyAttReportResApiResponse {
  readonly executionTime?: number;
  result?: StudentYearlyAttReportRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type StudyMode = typeof StudyMode[keyof typeof StudyMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StudyMode = {
  Regular: 0,
  Private: 1,
} as const;

export interface SubjectAllocation {
  department?: IdNameModel;
  course?: IdNameModel;
  schema?: IdNameModel;
  batch?: IdNameModel;
  teacher?: IdNameModel;
  /** @nullable */
  details?: Details[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface SubjectAllocationApiResponse {
  readonly executionTime?: number;
  result?: SubjectAllocation;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SubjectAllocationMasterDetailsReq {
  /** @nullable */
  departmentId?: string | null;
  /** @nullable */
  courseId?: string | null;
  /** @nullable */
  batchId?: string | null;
  /** @nullable */
  sectionId?: string | null;
  /** @nullable */
  semesterId?: string | null;
}

export interface SubjectAllocationMasterDetailsRes {
  /** @nullable */
  departments?: Master[] | null;
  /** @nullable */
  courses?: Master[] | null;
  /** @nullable */
  schema?: Master[] | null;
  /** @nullable */
  batches?: Master[] | null;
  /** @nullable */
  teachers?: Master[] | null;
  /** @nullable */
  sections?: Master[] | null;
  /** @nullable */
  semesters?: Master[] | null;
  /** @nullable */
  subjects?: Master[] | null;
}

export interface SubjectAllocationMasterDetailsResApiResponse {
  readonly executionTime?: number;
  result?: SubjectAllocationMasterDetailsRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SubjectAndAssessmentGroupForSingleStudent {
  assessmentId?: string;
  /** @nullable */
  groupData?: SubjectAndAssessmentLookUpForSingleStudent[] | null;
}

export interface SubjectAndAssessmentGroupForSingleStudentListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: SubjectAndAssessmentGroupForSingleStudent[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SubjectAndAssessmentLookUp {
  assessmentDetails?: Assessments;
  assessmentId?: string;
  subject?: IdNameModel;
  maxMarks?: number;
  passingMarks?: number;
  date?: string;
  time?: FromToModel;
  teacher?: IdNameModel;
  /** @nullable */
  students?: SubjectMarksDetails[] | null;
  examType?: ExamType;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface SubjectAndAssessmentLookUpForSingleStudent {
  assessmentDetails?: Assessments;
  assessmentId?: string;
  subject?: IdNameModel;
  maxMarks?: number;
  passingMarks?: number;
  date?: string;
  time?: FromToModel;
  teacher?: IdNameModel;
  students?: SubjectMarksDetails;
  examType?: ExamType;
}

export interface SubjectDetail {
  maxMarks?: number;
  passingMarks?: number;
  date?: string;
  time?: FromToModel;
}

export interface SubjectManualEntryModel {
  /** @nullable */
  students?: ManualAttDetail[] | null;
  entryDate?: string;
  section?: IdNameModel;
  subject?: IdNameModel;
  batch?: IdNameModel;
}

export interface SubjectMarksDetails {
  isPresent?: boolean;
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  subjectId?: string | null;
  obtainedMarks?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface SubjectSemsterListResponse {
  batch?: IdNameModel;
  /** @nullable */
  subjects?: IdNameModel[] | null;
  /** @nullable */
  semesters?: IdNameModel[] | null;
}

export interface SubjectSemsterListResponseApiResponse {
  readonly executionTime?: number;
  result?: SubjectSemsterListResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type SubjectType = typeof SubjectType[keyof typeof SubjectType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubjectType = {
  Undefined: 0,
  Core: 1,
  Elective: 2,
  CIT: 3,
} as const;

export interface SubjectWiseAttendanceResponse {
  /** @nullable */
  subjectId?: string | null;
  /** @nullable */
  subjectName?: string | null;
  /** @nullable */
  students?: AttSheetResponse[] | null;
}

export interface SubjectWiseAttendanceResponseListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: SubjectWiseAttendanceResponse[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SubmitAtt {
  batch?: IdNameModel;
  course?: IdNameModel;
  semester?: IdNameModel;
  subject?: IdNameModel;
  section?: IdNameModel;
  teacher?: IdNameModel;
  attDate?: string;
  /** @nullable */
  student?: StudentSubmitRes[] | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface SubmitAttApiResponse {
  readonly executionTime?: number;
  result?: SubmitAtt;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface SupportReq {
  /** @nullable */
  id?: string | null;
  status?: LeaveStatusEnum;
  /** @nullable */
  remark?: string | null;
  /** @nullable */
  note?: string | null;
  deviceDetails?: Device;
}

export interface SupportRequestRes {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  remark?: string | null;
  student?: IdNameModel;
  batch?: IdNameModel;
  approvedBy?: RecordUpdateInfo;
  status?: LeaveStatusEnum;
}

export interface SupportRequestResPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: SupportRequestRes[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface SupportRequestResPagedDataApiResponse {
  readonly executionTime?: number;
  result?: SupportRequestResPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface TeacherProfileRes {
  status?: ApplicationUserStatus;
  /** @nullable */
  address?: string | null;
  userImage?: FileNameModel;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  roles?: string[] | null;
  /** @nullable */
  teacherEmpId?: string | null;
  /** @nullable */
  subjects?: IdNameModel[] | null;
  joiningDate?: string;
  facultyType?: IdNameModel;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface TeacherProfileResApiResponse {
  readonly executionTime?: number;
  result?: TeacherProfileRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface TimeOptions {
  monday?: FromToModel;
  tuesday?: FromToModel;
  wednesday?: FromToModel;
  thursday?: FromToModel;
  friday?: FromToModel;
  saturday?: FromToModel;
  sunday?: FromToModel;
}

export interface TimeSchedule {
  enquiry?: IdNameModel;
  shift?: IdNameModel;
  fromDate?: string;
  lunchTime?: number;
  isLunchCal?: boolean;
  /** @nullable */
  batchDays?: BatchDaysModel[] | null;
  /** @nullable */
  punchInTime?: string | null;
  /** @nullable */
  punchOutTime?: string | null;
  perDayWH?: number;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface TimeScheduleApiResponse {
  readonly executionTime?: number;
  result?: TimeSchedule;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface TimeScheduleListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: TimeSchedule[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface TitDes {
  /** @nullable */
  title?: string | null;
  /** @nullable */
  description?: string | null;
}

export interface TopicModel {
  /** @nullable */
  topic?: string | null;
  no?: number;
}

export interface Units {
  /** @nullable */
  chapter?: string | null;
  no?: number;
  /** @nullable */
  topics?: TopicModel[] | null;
}

export interface UpdateExamQueryStatusReq {
  /** @nullable */
  queryId?: string | null;
  /** @nullable */
  remark?: string | null;
  status?: StatusEnum;
  mark?: number;
}

export interface UpdateStudentAllAnswerRequest {
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  examId?: string | null;
  /** @nullable */
  questionAnswer?: QuestionAnswerModel[] | null;
}

export interface UpdateStudentAnswerRequest {
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  examId?: string | null;
  /** @nullable */
  questionId?: string | null;
  /** @nullable */
  studentAnswer?: string | null;
}

export interface UpdateStudentCourseReq {
  /** @nullable */
  id?: string | null;
  batch?: IdNameModel;
  department?: IdNameModel;
  course?: IdNameModel;
  semester?: IdNameModel;
  section?: IdNameModel;
}

export interface UpdateStudentReq {
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  machineNo?: string | null;
  isMachineRemove?: boolean;
}

export interface UserLog {
  entityRef?: MongoDBRef;
  entity?: EntitiesEnum;
  isProcessStepChange?: boolean;
  masterType?: MasterType;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  icon?: string | null;
  action?: UserLogActions;
  logEntity?: IdNameModel;
  /** @nullable */
  changes?: Changes[] | null;
  /** @nullable */
  entityName?: string | null;
  /** @nullable */
  incrementalSeries?: string | null;
  enquiryType?: EnquiryType;
  isRejected?: boolean;
  isEnrolled?: boolean;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export type UserLogActions = typeof UserLogActions[keyof typeof UserLogActions];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserLogActions = {
  Undefined: 0,
  Insert: 1,
  Update: 2,
  Delete: 3,
  DeleteMany: 4,
  Approved: 5,
  EnquiryReject: 6,
  ProcessStepChanged: 7,
} as const;

export interface UserLogInRequest {
  /** @minLength 1 */
  userName: string;
  /** @minLength 1 */
  password: string;
}

export interface UserLogInResponse {
  /** @nullable */
  token?: string | null;
  /** @nullable */
  name?: string | null;
  tokenExpiry?: number;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  employeeId?: string | null;
  company?: IdNameModel;
  branch?: IdNameModel;
  initPasswordChanged?: boolean;
  isWFHAllowed?: boolean;
  status?: ApplicationUserStatus;
  /** @nullable */
  roles?: string[] | null;
  rights?: Rights;
  /** @nullable */
  otp?: string | null;
  /** @nullable */
  enquiryId?: string | null;
  isDefaultPassword?: boolean;
  isFirst2FASuggestion?: boolean;
  userImage?: FileNameModel;
  /** @nullable */
  departments?: IdNameModel[] | null;
  roleType?: RoleTypes;
  studentDetails?: Enquiry;
  isFirstLogin?: boolean;
  requiresTwoFactor?: boolean;
  twoFactorSuccess?: boolean;
}

export interface UserLogInResponseApiResponse {
  readonly executionTime?: number;
  result?: UserLogInResponse;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface UserLogPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: UserLog[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface UserLogPagedDataApiResponse {
  readonly executionTime?: number;
  result?: UserLogPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type UserType = typeof UserType[keyof typeof UserType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserType = {
  All: 0,
  Admin: 1,
  Student: 2,
  Counsellor: 3,
  Mentor: 4,
  Accountant: 5,
  Teacher: 6,
  SuperAdmin: 7,
} as const;

export interface Verify2FARequest {
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  code?: string | null;
}

export interface ViewStudentListForIdCard {
  /** @nullable */
  studentId?: string | null;
  /** @nullable */
  departmentName?: string | null;
  /** @nullable */
  courseName?: string | null;
  /** @nullable */
  batchName?: string | null;
  /** @nullable */
  semeseterName?: string | null;
  /** @nullable */
  sectionName?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  id?: string | null;
}

export interface ViewStudentListForIdCardListApiResponse {
  readonly executionTime?: number;
  /** @nullable */
  result?: ViewStudentListForIdCard[] | null;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type ViewType = typeof ViewType[keyof typeof ViewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ViewType = {
  Undefined: 0,
  CV: 1,
  Enroll: 2,
} as const;

export interface WebEnquiryFromRes {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  middleName?: string | null;
  /** @nullable */
  lastName?: string | null;
  contactDetail?: ContactDetail;
  /** @nullable */
  qualification?: string | null;
  counsellingSession?: boolean;
}

export interface WebEnquiryFromResApiResponse {
  readonly executionTime?: number;
  result?: WebEnquiryFromRes;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface WebsiteEnquiry {
  sno?: number;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  lastName?: string | null;
  /** @nullable */
  email?: string | null;
  mobileNumber?: number;
  gender?: IdNameModel;
  source?: IdNameModel;
  /** @nullable */
  city?: string | null;
  state?: IndianState;
  board?: IdNameModel;
  stream?: IdNameModel;
  medium?: IdNameModel;
  dob?: string;
  class?: IdNameModel;
  /** @nullable */
  passingYear?: string | null;
  course?: IdNameModel;
  department?: IdNameModel;
  classStatus?: ClassStatus;
  /** @nullable */
  remark?: string | null;
  company?: IdNameModel;
  recordStatus?: RecordStatusType;
  /** @nullable */
  id?: string | null;
  createdBy?: RecordUpdateInfo;
  updatedBy?: RecordUpdateInfo;
}

export interface WebsiteEnquiryApiResponse {
  readonly executionTime?: number;
  result?: WebsiteEnquiry;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export interface WebsiteEnquiryGroupDataRes {
  recordStatus?: RecordStatusType;
  count?: number;
}

export interface WebsiteEnquiryPagedData {
  totalRecords?: number;
  moreRecords?: boolean;
  /** @nullable */
  items?: WebsiteEnquiry[] | null;
  /** @nullable */
  continuationToken?: string | null;
}

export interface WebsiteEnquiryPagedDataApiResponse {
  readonly executionTime?: number;
  result?: WebsiteEnquiryPagedData;
  status?: boolean;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  errors?: ApiError[] | null;
}

export type WeekDay = typeof WeekDay[keyof typeof WeekDay];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WeekDay = {
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7,
} as const;

export interface WorkingDays {
  mon?: boolean;
  tues?: boolean;
  wed?: boolean;
  thu?: boolean;
  fri?: boolean;
  sat?: boolean;
  sun?: boolean;
}

export type GetAPIAnswerSheetGetStudentAnswerSheetsListParams = {
examId?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
search?: string;
};

export type GetAPIAnswerSheetGetExamIndividualStudentAnswerSheetParams = {
examId?: string;
studentId?: string;
};

export type GetAPIAnswerSheetDeleteStudentMarksParams = {
id?: string;
};

export type PostAPIAnswerSheetResumeStudentExamParams = {
id?: string;
resume?: boolean;
};

export type GetAPIAssessmentsGetAssessmentsParams = {
id?: string;
departmentSearch?: string;
batch?: string;
status?: string;
start?: number;
length?: number;
category?: string;
semester?: string;
search?: string;
};

export type GetAPIAssessmentsGetAssessmentByIdParams = {
id?: string;
};

export type PostAPIAssessmentsUpdateAssessmentStatusParams = {
Id?: string;
status?: string;
};

export type GetAPIAssessmentsGetAssessmentsWeightParams = {
IsCommon?: boolean;
};

export type PostAPIAssessmentsAssessmentsWeightParams = {
IsCommon?: boolean;
};

export type PostAPIAssessmentsAssessmentsWeightWithDetailParams = {
IsCommon?: boolean;
};

export type GetAPIAssessmentsGetAssessmentByDesignCourseParams = {
departmentId?: string;
courseId?: string;
batchId?: string;
semesterId?: string;
sectionId?: string;
categoryId?: string;
};

export type GetAPIAssessmentsGetAssessmentByDesignCourseForSingleStudentParams = {
departmentId?: string;
courseId?: string;
batchId?: string;
semesterId?: string;
sectionId?: string;
categoryId?: string;
assessmentId?: string;
studentId?: string;
};

export type GetAPIAssessmentsGetStudentByAssessmentParams = {
assessmentId?: string;
};

export type GetAPIAssessmentsGetSubjectMarksParams = {
assessmentId?: string;
};

export type GetAPIAssessmentsDownloadSubjectMarksCsvParams = {
assessmentId?: string;
};

export type GetAPIAssessmentsGetAssessmentSubjectParams = {
assessmentId?: string;
};

export type GetAPIAssessmentsGetStudentByAssessmentSubjectParams = {
assessmentId?: string;
subjectId?: string;
};

export type GetAPIAssessmentsGetResultByDesignCourseParams = {
departmentId?: string;
courseId?: string;
batchId?: string;
semesterId?: string;
sectionId?: string;
studentId?: string;
categoryId?: string;
From?: string;
To?: string;
};

export type GetAPIAssessmentsGetSingleStudentResultCsvParams = {
departmentId?: string;
courseId?: string;
batchId?: string;
semesterId?: string;
sectionId?: string;
studentId?: string;
categoryId?: string;
From?: string;
To?: string;
};

export type GetAPIAssessmentsGetIndivitualStudentResultParams = {
departmentId?: string;
courseId?: string;
batchId?: string;
semesterId?: string;
sectionId?: string;
studentId?: string;
categoryId?: string;
assessmentId?: string;
};

export type GetAPIAssessmentsGetAssessmentAndSubjectDetailsParams = {
assessmentId?: string;
subjectId?: string;
type?: ExamType;
};

export type GetAPIAssessmentsGetSemstersListByBatchParams = {
batch?: string;
};

export type PostAPIAssessmentsPublishAssessmentResultsNotificationParams = {
assessmentId?: string;
};

export type GetAPIAttendanceAttendanceSheetParams = {
month?: number;
year?: number;
batchId?: string;
departmentId?: string;
start?: number;
length?: number;
};

export type GetAPIAttendanceGetAllAttByBatchAndDateParams = {
date?: string;
batchId?: string;
start?: number;
length?: number;
};

export type GetAPIAttendanceGetAllAttByBatchParams = {
batchId?: string;
departmentId?: string;
};

export type GetAPIAttendanceGetAllStudentListYearMonthParams = {
batch?: string;
};

export type GetAPIAttendanceGetAttByIdStuIdParams = {
date?: string;
id?: string;
};

export type GetAPIAttendanceGetAllStudentAttendanceParams = {
date?: string;
departmentId?: string;
batchId?: string;
name?: string;
attandanceFilter?: AttandanceStatusType;
};

export type GetAPIAttendanceGetSubjectWiseAttendanceListParams = {
subject?: string;
date?: string;
};

export type GetAPIAttendanceDownloadSheetParams = {
month?: number;
year?: number;
batchId?: string;
start?: number;
length?: number;
};

export type GetAPIAttendanceGetSubjectWiseAttandanceSheetParams = {
month?: number;
year?: number;
batchId?: string;
subjectId?: string;
start?: number;
length?: number;
};

export type GetAPIAttendanceGetBatchwiseSubjectsParams = {
batchId?: string;
semesterId?: string;
};

export type GetAPIAttendanceGetBatchWiseStudentsParams = {
batchId?: string;
};

export type GetAPIAuthUserListParams = {
userType?: UserType;
nameSearch?: string;
roleSearch?: string;
mailSearch?: string;
phoneNumberSearch?: string;
status?: number;
start?: number;
length?: number;
};

export type GetAPIAuthGetUserParams = {
id?: string;
};

export type PostAPIAuthResetUserPasswordParams = {
userId?: string;
};

export type GetAPICompanyGetAllCompanyListParams = {
status?: string;
search?: string;
sortCol?: string;
sortDir?: string;
start?: number;
length?: number;
};

export type PostAPICompanyUpdateCompanyStatusParams = {
objId?: string;
action?: string;
};

export type GetAPICreateScheduleGetAllListParams = {
start?: number;
departmentSearch?: string;
length?: number;
sortCol?: string;
sortDir?: string;
categorySearch?: string;
type?: ScheduleCategory;
batch?: string;
};

export type GetAPICreateScheduleGetByIdParams = {
id?: string;
};

export type GetAPICreateScheduleGetScheduleItemListParams = {
scheduleId?: string;
sectionId?: string;
};

export type PostAPICreateScheduleDeleteScheduleParams = {
scheduleId?: string;
};

export type PostAPICreateScheduleUpdateScheduleListParams = {
ScheduleId?: string;
SectionId?: string;
};

export type GetAPICreateScheduleGetScheduleListWithTimeParams = {
ScheduleId?: string;
SectionId?: string;
SubjectId?: string;
TeacherId?: string;
StartTime?: string;
EndTime?: string;
};

export type GetAPICreateScheduleGetScheduleListByIdParams = {
scheduleItemId?: string;
};

export type PostAPICreateScheduleUpdateStatusParams = {
Id?: string;
Status?: boolean;
};

export type GetAPIDashBoardGetStudentStatusParams = {
batchId?: string;
departmentId?: string;
};

export type GetAPIDashBoardGetStraeamDataParams = {
name?: string;
start?: number;
length?: number;
batch?: string;
};

export type GetAPIDashBoardGetSourseByDateParams = {
From?: string;
To?: string;
};

export type GetAPIDashBoardGetEnquiryBySourceParams = {
source?: string;
From?: string;
To?: string;
sourceFilter?: boolean;
search?: string;
start?: number;
length?: number;
};

export type GetAPIEnquiryGetListParams = {
type?: CandidateRequestType;
filterId?: string;
batchSearch?: string;
departmentSearch?: string;
nameSearch?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
userRoleId?: string;
streamSearch?: string;
fatherName?: string;
phoneNo?: number;
exists?: StudentExist;
source?: string;
centerVisited?: CenterVisited;
responseType?: Response;
counselors?: string[];
processStep?: ProcessStepsEnum;
From?: string;
To?: string;
sourceFilter?: boolean;
};

export type GetAPIEnquiryGetByIdParams = {
id?: string;
};

export type GetAPIEnquiryGetEnquiryFormParams = {
id?: string;
};

export type PostAPIEnquirySaveParams = {
type?: CandidateRequestType;
};

export type GetAPIEnquiryGetCsvParams = {
exists?: StudentExist;
requestType?: CandidateRequestType;
filterId?: string;
batchSearch?: string;
departmentSearch?: string;
nameSearch?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
userRoleId?: string;
streamSearch?: string;
};

export type PostAPIEnquiryUpdateParams = {
id?: string;
fieldName?: string;
valueType?: string;
};

export type PostAPIEnquiryUpdateListParams = {
id?: string;
fieldName?: string;
valueType?: string;
};

export type PostAPIEnquiryAddAttachmentParams = {
id?: string;
fieldName?: string;
valueType?: string;
};

export type PostAPIEnquiryRemoveAttachmentsParams = {
id?: string;
attachmentId?: string;
fieldName?: string;
};

export type PostAPIEnquiryAddCredentialsParams = {
id?: string;
};

export type GetAPIEnquiryGetListWithIdNameParams = {
search?: string;
};

export type GetAPIEnquiryExistsParams = {
id?: string;
activity?: boolean;
reason?: string;
reAdmission?: boolean;
};

export type GetAPIEnquiryGetStudentIdParams = {
year?: string;
};

export type PostAPIEnquiryAssignCardParams = {
studentId?: string;
};

export type PostAPIEnquiryGetStudentCardParams = {
studentId?: string;
};

export type PostAPIEnquiryResyncStudentParams = {
studentId?: string;
};

export type PostAPIEnquiryDeleteStudentCardParams = {
studentId?: string;
};

export type GetAPIEnquiryGetByUserIdParams = {
id?: string;
};

export type GetAPIEnquiryStudentWithOutBioDeviceAssignParams = {
machineCode?: string;
search?: string;
};

export type GetAPIEnquiryStudentBioDeviceAssignParams = {
machineCode?: string;
search?: string;
bioDeviceOptions?: BioDeviceOptionsEnum;
};

export type PostAPIEnquiryUploadProfileParams = {
enquiryId?: string;
};

export type GetAPIEnquiryGetNotAssignedEnquiriesParams = {
Start?: number;
Length?: number;
Search?: string;
SortCol?: string;
SortDir?: string;
Action?: EnquiryCounselorType;
CounselorId?: string;
};

export type GetAPIEnquiryGetEnquiryCallListParams = {
CallStatus?: EnquiryCallStatusEnum;
Search?: string;
Counselor?: string;
From?: string;
To?: string;
};

export type GetAPIEnquiryGetEnquiryListParams = {
start?: number;
length?: number;
year?: string;
sortCol?: string;
sortDir?: string;
exists?: StudentExist;
type?: CandidateRequestType;
};

export type PostAPIEnquiryUploadBody = {
  file?: Blob;
};

export type PostAPIEnquiryCommunicationUpdateParams = {
CommunicationTypeId?: string;
};

export type GetAPIEnquiryCommunicationGetAllListParams = {
EnquiryId?: string;
type?: CommunicationType;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
note?: string;
createdby?: string;
phoneNo?: string;
callType?: CallType;
outComeType?: OutcomeType;
subject?: string;
toMail?: string;
title?: string;
meetingType?: MeetingType;
meetingAddress?: string;
taskType?: string;
};

export type GetAPIEnquiryCommunicationGetByIdParams = {
EnquiryId?: string;
};

export type GetAPIEnquiryCommunicationCommunicationGetByIdParams = {
Id?: string;
type?: CommunicationType;
};

export type GetAPIEnquiryCommunicationGetEnrollPdfParams = {
enqId?: string;
type?: ViewType;
};

export type GetAPIEnquiryCommunicationGetDownloadViewParams = {
enqId?: string;
type?: ViewType;
};

export type GetAPIEnquiryCommunicationMonthlyCallLogReportParams = {
userId?: string;
month?: number;
year?: number;
};

export type GetAPIEnquiryCommunicationCheckLeadToTataReportParams = {
'Counsellor.Name'?: string;
'Counsellor.Id'?: string;
Start?: string;
};

export type GetAPIExamGetExamPaperListParams = {
departmentId?: string;
semester?: string;
batchId?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
search?: string;
WatchCheck?: boolean;
};

export type GetAPIExamGetExamPaperAndQuestionsDetailsParams = {
assessmentId?: string;
subjectId?: string;
type?: ExamType;
};

export type GetAPIExamDeleteQuestionAndExamPaperParams = {
id?: string;
};

export type GetAPIExamGetStudentExamListParams = {
start?: number;
lenght?: number;
};

export type PostAPIExamChangeExamRecordStatusParams = {
examId?: string;
type?: RecordStatusType;
};

export type GetAPIExamCheckExistStudentAnswerSheetParams = {
studentId?: string;
examId?: string;
};

export type PostAPIExamUpdateExamRecordStatusParams = {
id?: string;
IsFinalDisplay?: boolean;
};

export type GetAPIExamQueriesGetExamQueryParams = {
AnswerSheetId?: string;
AnswerId?: string;
};

export type GetAPIExamQueriesGetExamQueriesListParams = {
department?: string;
status?: StatusEnum;
search?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
batch?: string;
};

export type GetAPIFeesMasterGetFeesMasterListParams = {
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
status?: string;
};

export type GetAPIFeesMasterGetFeesStructureDetailsByEnquiryIdParams = {
enquiryId?: string;
};

export type PostAPIFeesMasterUpdateFeesStructureStatusParams = {
Id?: string;
action?: string;
};

export type GetAPIHDFCPaymentGetDetailsParams = {
Id?: string;
Type?: PaymentType;
};

export type GetAPIHDFCPaymentCheckOrderStatusParams = {
orderId?: string;
};

export type GetAPIHDFCPaymentGetOrderDetailsParams = {
orderId?: number;
};

export type GetAPIHDFCPaymentGetPaymentApprovalListParams = {
Start?: number;
Length?: number;
Search?: string;
SortCol?: string;
SortDir?: string;
PaymentStatus?: HdfcOrderStatus;
};

export type GetAPIHDFCPaymentGetPaymentOrderListParams = {
Start?: number;
Length?: number;
Search?: string;
SortCol?: string;
SortDir?: string;
PaymentStatus?: HdfcOrderStatus;
};

export type GetAPIMastersParams = {
masterType?: MasterType;
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
status?: string;
};

export type PostAPIMastersUpdateRecordStatusParams = {
objId?: string;
restore?: string;
};

export type GetAPIMastersIdParams = {
masterType?: MasterType;
};

export type GetAPIMastersDeleteParams = {
id?: string;
type?: MasterType;
};

export type GetAPIMastersSearchParams = {
type?: MasterType;
start?: number;
length?: number;
search?: string;
};

export type GetAPIMastersBatchSearchingParams = {
masterType?: MasterType;
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
departmentId?: string;
courseId?: string;
};

export type GetAPIMastersSchemasParams = {
courseId?: string;
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
};

export type GetAPIMastersSubjectsByDepartmentParams = {
departmentId?: string;
};

export type GetAPIMastersGetBatchByDepartmentParams = {
departmentId?: string;
};

export type GetAPIMastersSemestersByDepartmentParams = {
departmentId?: string;
};

export type GetAPIMastersCoursesByDepartmentParams = {
departmentId?: string;
};

export type GetAPIMastersSchemasByCourseParams = {
departmentId?: string;
};

export type PostAPIMastersCurrentSchemaParams = {
courseId?: string;
};

export type GetAPIMastersCurrentSchemasByCourseParams = {
departmentId?: string;
courseId?: string;
};

export type GetAPIMastersSemesterWithSubjectsParams = {
courseId?: string;
schemaId?: string;
};

export type PostAPIMastersStatusActionParams = {
masterType?: MasterType;
};

export type PostAPIMastersStatusActionBody = {
  saveRequestList?: string[];
};

export type GetAPIMastersGetAllMastersParams = {
start?: number;
length?: number;
};

export type GetAPIMastersGetSemesterDataParams = {
masterType?: MasterType;
};

export type GetAPIMastersGetSessionListByCourseIdParams = {
courseId?: string;
};

export type GetAPIMastersGetSemesterListBySessionIdParams = {
sessionId?: string;
};

export type GetAPIMastersGetSubjectListBySessionIdParams = {
subjectId?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
};

export type PostAPIMastersUpdateRecordStatusForShiftParams = {
objId?: string;
restore?: string;
};

export type PostAPIMastersUpdateFacultyDetailRecordStatusParams = {
objId?: string;
action?: string;
};

export type GetAPIMastersGetStudentListParams = {
search?: string;
departmentId?: string;
batchId?: string;
};

export type GetAPIMastersGetStudentIDCardDetailsParams = {
StudentIds?: string;
};

export type GetAPIMastersDownloadCardsPdfParams = {
studentIds?: string;
};

export type GetAPIPaymentGetAllParams = {
id?: string;
studentId?: string;
};

export type PostAPIPaymentGetByParams = {
id?: string;
index?: number;
};

export type GetAPIPaymentGetListParams = {
search?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
streamSearch?: string;
batchSearch?: string;
departmentSearch?: string;
feesType?: string;
status?: string;
};

export type PostAPIPaymentUpdateParams = {
id?: string;
fieldName?: string;
valueType?: string;
};

export type PostAPIPaymentUpdateListParams = {
id?: string;
fieldName?: string;
valueType?: string;
};

export type GetAPIPaymentGetPdfParams = {
Index?: number;
Id?: string;
};

export type GetAPIPaymentDownloadPdfParams = {
Index?: number;
Id?: string;
};

export type GetAPIPaymentDownloadBothPdfParams = {
Index?: number;
Id?: string;
};

export type GetAPIPaymentDownloadCSVParams = {
streamSearch?: string;
batchSearch?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
status?: string;
};

export type GetAPIPaymentDownloadFileDownloadParams = {
url?: string;
};

export type GetAPIPersonCallLogsGetCallLogsParams = {
enquiryStatus?: string;
search?: string;
sortCol?: string;
sortDir?: string;
from?: string;
to?: string;
callStatusSearch?: string;
callTypeSearch?: string;
start?: number;
length?: number;
};

export type GetAPIPersonCallLogsGetPersonCallHistoryParams = {
id?: string;
};

export type GetAPIPersonCallLogsGetPersonRejectDetailsParams = {
id?: string;
};

export type PostAPIPrivacyPolicyUpdateRecordStatusParams = {
Id?: string;
action?: string;
};

export type GetAPIPrivacyPolicyGetPrivacyPolicyListParams = {
search?: string;
start?: number;
length?: number;
sortCol?: string;
sortDir?: string;
status?: string;
};

export type GetAPIReportsGetStudentsReportsParams = {
batchId?: string;
startTime?: string;
endTime?: string;
searchTerm?: string;
};

export type GetAPIReportsDownloadReportCsvParams = {
batchId?: string;
startTime?: string;
endTime?: string;
};

export type GetAPIReportsGetMonthlyReportParams = {
batchId?: string;
year?: number;
month?: number;
searchTerm?: string;
};

export type GetAPIReportsDownloadMonthlyReportCsvParams = {
batchId?: string;
year?: number;
month?: number;
searchTerm?: string;
};

export type GetAPIRequestLeaveApplicationAdminParams = {
status?: LeaveStatusEnum;
leaveType?: string;
searchTerm?: string;
page?: number;
pageSize?: number;
departmentId?: string;
batchId?: string;
};

export type GetAPIRequestGetLeaveTypesParams = {
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
status?: string;
};

export type PostAPIRequestUpdateLeaveRecordStatusParams = {
Id?: string;
action?: string;
};

export type GetAPIRequestGetAttendanceReqParams = {
page?: number;
pageSize?: number;
type?: AttRequestType;
searchTerm?: string;
batchId?: string;
departmentId?: string;
};

export type GetAPIRequestGetSupportReqListParams = {
page?: number;
pageSize?: number;
searchTerm?: string;
batchId?: string;
departmentId?: string;
};

export type PostAPISubjectAllocationUpdateParams = {
AllocationId?: string;
};

export type GetAPISubjectAllocationGetSubAllocationListParams = {
departmentId?: string;
start?: number;
length?: number;
search?: string;
sortCol?: string;
sortDir?: string;
batch?: string;
semester?: string;
};

export type GetAPISubjectAllocationGetSubjectAllocationByIdParams = {
id?: string;
};

export type GetAPITataAuthTokenGetCounsellorReportParams = {
'Counsellor.Name'?: string;
'Counsellor.Id'?: string;
Month?: number;
Year?: number;
};

export type GetAPITimeScheduleGetTimeScheduleByEnquiryIdParams = {
enquiryId?: string;
};

export type GetAPITimeScheduleGetTimeScheduleListByEnquiryIdParams = {
enquiryId?: string;
};

export type GetApiUserLogsParams = {
entityId?: string;
entity?: EntitiesEnum;
start?: number;
length?: number;
};

